// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AppGetHelloResponse, AppHealthCheckResponse, AuthLoginData, AuthLoginResponse, AuthLogoutResponse, AuthGetCurrentUserResponse, AuthRefreshResponse, RolesGetAllResponse, RolesCreateData, RolesCreateResponse, RolesGetOneData, RolesGetOneResponse, RolesUpdateData, RolesUpdateResponse, RolesDeleteData, RolesDeleteResponse, ClientAuthSendCodeData, ClientAuthSendCodeResponse, ClientAuthLoginData, ClientAuthLoginResponse, ClientAuthRefreshData, ClientAuthRefreshResponse, ClientAuthRegisterData, ClientAuthRegisterResponse, ClientAuthSetPhoneData, ClientAuthSetPhoneResponse, AdminAuthSendCodeData, AdminAuthSendCodeResponse, AdminAuthLoginData, AdminAuthLoginResponse, AdminAuthExchangeImpersonationCodeData, AdminAuthExchangeImpersonationCodeResponse, ClientGetMeResponse, ClientUpdateMeData, ClientUpdateMeResponse, ClientRequestDeleteAccountResponse, ClientListCarsResponse, ClientCreateCarData, ClientCreateCarResponse, ClientGetCarData, ClientGetCarResponse, ClientUpdateCarData, ClientUpdateCarResponse, ClientDeleteCarData, ClientDeleteCarResponse, ClientListBookingsResponse, ClientConfirmDeleteAccountData, ClientConfirmDeleteAccountResponse, ClientRequestDeleteAccountByPhoneData, ClientRequestDeleteAccountByPhoneResponse, ClientConfirmDeleteAccountByPhoneData, ClientConfirmDeleteAccountByPhoneResponse, AdminSearchClientsData, AdminSearchClientsResponse, AdminFindOrCreateClientData, AdminFindOrCreateClientResponse, AdminCreateOrUpdateCarData, AdminCreateOrUpdateCarResponse, SuperadminListClientsData, SuperadminListClientsResponse, SuperadminGetClientsSummaryData, SuperadminGetClientsSummaryResponse, SuperadminGroupClientsData, SuperadminGroupClientsResponse, SuperadminGetClientData, SuperadminGetClientResponse, SuperadminGetClientStatsData, SuperadminGetClientStatsResponse, SuperadminGetClientTransactionsData, SuperadminGetClientTransactionsResponse, SuperadminGetClientBookingsData, SuperadminGetClientBookingsResponse, ServiceCenterListData, ServiceCenterListResponse, ServiceCenterGetOneData, ServiceCenterGetOneResponse, ServiceCenterGetSlotsData, ServiceCenterGetSlotsResponse, ServiceCenterToggleFavoriteData, ServiceCenterToggleFavoriteResponse, AdminGetServiceCenterPostsData, AdminGetServiceCenterPostsResponse, AdminCreateServiceCenterPostData, AdminCreateServiceCenterPostResponse, AdminDeleteServiceCenterPostData, AdminDeleteServiceCenterPostResponse, AdminUpdateServiceCenterPostData, AdminUpdateServiceCenterPostResponse, AdminGetServiceCenterLegalDataData, AdminGetServiceCenterLegalDataResponse, AdminUpdateServiceCenterLegalDataData, AdminUpdateServiceCenterLegalDataResponse, AdminGetServiceCenterContractorDataData, AdminGetServiceCenterContractorDataResponse, AdminUpdateServiceCenterContractorDataData, AdminUpdateServiceCenterContractorDataResponse, AdminGetSbpBanksData, AdminGetSbpBanksResponse, AdminGenerateContractData, AdminGenerateContractResponse, AdminDownloadContractData, AdminDownloadContractResponse, AdminGetContractLinkData, AdminGetContractLinkResponse, AdminRegisterServiceCenterInTBankData, AdminRegisterServiceCenterInTBankResponse, AdminGetServiceCenterTBankRegistrationStatusData, AdminGetServiceCenterTBankRegistrationStatusResponse, SuperadminListServiceCentersData, SuperadminListServiceCentersResponse, SuperadminCreateServiceCenterData, SuperadminCreateServiceCenterResponse, SuperadminGetServiceCentersSummaryData, SuperadminGetServiceCentersSummaryResponse, SuperadminGetServiceCenterStatsData, SuperadminGetServiceCenterStatsResponse, SuperadminImpersonateServiceCenterData, SuperadminImpersonateServiceCenterResponse, SuperadminGetServiceCenterData, SuperadminGetServiceCenterResponse, SuperadminUpdateServiceCenterData, SuperadminUpdateServiceCenterResponse, SuperadminDeleteServiceCenterData, SuperadminDeleteServiceCenterResponse, SuperadminGetServiceCenterTransactionsData, SuperadminGetServiceCenterTransactionsResponse, SuperadminGetServiceCenterBookingsData, SuperadminGetServiceCenterBookingsResponse, SuperadminGetServiceCenterPayoutsData, SuperadminGetServiceCenterPayoutsResponse, SuperadminListServiceCenterAdminsData, SuperadminListServiceCenterAdminsResponse, SuperadminCreateServiceCenterAdminData, SuperadminCreateServiceCenterAdminResponse, SuperadminGetServiceCenterAdminData, SuperadminGetServiceCenterAdminResponse, SuperadminUpdateServiceCenterAdminData, SuperadminUpdateServiceCenterAdminResponse, SuperadminDeleteServiceCenterAdminData, SuperadminDeleteServiceCenterAdminResponse, SuperadminGetPayoutDetailData, SuperadminGetPayoutDetailResponse, SuperadminPayoutRequestData, SuperadminPayoutRequestResponse, SuperadminPayoutConfirmData, SuperadminPayoutConfirmResponse, OperatingHoursGetAllData, OperatingHoursGetAllResponse, OperatingHoursUpdateRegularData, OperatingHoursUpdateRegularResponse, OperatingHoursCreateSpecialData, OperatingHoursCreateSpecialResponse, OperatingHoursUpdateData, OperatingHoursUpdateResponse, OperatingHoursDeleteData, OperatingHoursDeleteResponse, PaymentsControllerPaymentSuccessData, PaymentsControllerPaymentSuccessResponse, PaymentsControllerPaymentFailData, PaymentsControllerPaymentFailResponse, PaymentsControllerHandleTBankWebhookData, PaymentsControllerHandleTBankWebhookResponse, PaymentsControllerGetAllPaymentsResponse, PaymentsControllerInitPaymentData, PaymentsControllerInitPaymentResponse, PaymentsControllerGetPaymentStatusData, PaymentsControllerGetPaymentStatusResponse, PaymentsControllerCancelPaymentData, PaymentsControllerCancelPaymentResponse, SuperadminGroupPaymentsData, SuperadminGroupPaymentsResponse, SuperadminListPaymentsResponse, SuperadminGetPaymentEventsData, SuperadminGetPaymentEventsResponse, SuperadminGetPaymentDetailData, SuperadminGetPaymentDetailResponse, SuperadminTriggerPayoutData, SuperadminTriggerPayoutResponse, ReceiptsControllerHandleWebhookData, ReceiptsControllerHandleWebhookResponse, ReceiptsControllerGetReceiptsByPaymentData, ReceiptsControllerGetReceiptsByBookingData, BookingCreateData, BookingCreateResponse, BookingListData, BookingListResponse, BookingGetOneData, BookingGetOneResponse, BookingCancelData, BookingCancelResponse, BookingGetPaymentData, BookingGetPaymentResponse, AdminBookingsGetListData, AdminBookingsGetListResponse, AdminCreateBookingData, AdminCreateBookingResponse, AdminBookingsGetPendingData, AdminBookingsGetPendingResponse, AdminBookingsGetOneData, AdminBookingsGetOneResponse, AdminBookingsUpdateData, AdminBookingsUpdateResponse, AdminBookingsUpdateStatusData, AdminBookingsUpdateStatusResponse, MasterBookingsGetListData, MasterBookingsGetListResponse, SuperadminGroupBookingsData, SuperadminGroupBookingsResponse, SuperadminListBookingsResponse, RegisterNotificationTokenData, RegisterNotificationTokenResponse, UnregisterNotificationTokenData, UnregisterNotificationTokenResponse, GetNotificationSettingsResponse, UpdateNotificationSettingsData, UpdateNotificationSettingsResponse, GetNotificationsData, GetNotificationsResponse, MarkNotificationAsReadData, MarkNotificationAsReadResponse, MarkAllNotificationsAsReadResponse, GetUnreadNotificationsCountResponse, SuperadminListPushableClientsData, SuperadminListPushableClientsResponse, SuperadminSendPushNotificationsData, SuperadminSendPushNotificationsResponse, CarsControllerGetMakesData, CarsControllerGetMakesResponse, CarsControllerGetModelsByMakeIdData, CarsControllerGetModelsByMakeIdResponse, AdminSearchCarsData, AdminSearchCarsResponse, AdminServicesGetAllData, AdminServicesGetAllResponse, AdminServicesCreateData, AdminServicesCreateResponse, AdminServicesGetOneData, AdminServicesGetOneResponse, AdminServicesUpdateData, AdminServicesUpdateResponse, AdminServicesDeleteData, AdminServicesDeleteResponse, AdminAnalyticsGetStatsData, AdminAnalyticsGetStatsResponse, AdminAnalyticsGetTopServicesData, AdminAnalyticsGetTopServicesResponse, AdminAnalyticsGetLoadChartData, AdminAnalyticsGetLoadChartResponse, AuditLogsListData, AuditLogsListResponse, AuditLogGetData, AuditLogGetResponse, DadataControllerSuggestPartyData, DadataControllerSuggestPartyResponse, DadataControllerFindPartyData, DadataControllerFindPartyResponse, DadataControllerSuggestBankData, DadataControllerSuggestBankResponse, DadataControllerFindBankData, DadataControllerFindBankResponse, DadataControllerSuggestAddressData, DadataControllerSuggestAddressResponse, DadataControllerCleanAddressData, DadataControllerCleanAddressResponse, AdminFeedbackSettingsGetResponse, AdminFeedbackSettingsUpdateData, AdminFeedbackSettingsUpdateResponse, FeedbackTopicsListResponse, AdminFeedbackTopicCreateData, AdminFeedbackTopicCreateResponse, AdminFeedbackTopicListResponse, AdminFeedbackTopicUpdateData, AdminFeedbackTopicUpdateResponse, AdminFeedbackTopicDeleteData, AdminFeedbackTopicDeleteResponse, FeedbackCreateData, FeedbackCreateResponse, AdminFeedbackListData, AdminFeedbackListResponse, AdminFeedbackGetOneData, AdminFeedbackGetOneResponse, AdminFeedbackDeleteData, AdminFeedbackDeleteResponse, AdminFeedbackAddCommentData, AdminFeedbackAddCommentResponse, AdminFeedbackUpdateStatusData, AdminFeedbackUpdateStatusResponse, FaqListResponse, AdminFaqCreateData, AdminFaqCreateResponse, AdminFaqListResponse, AdminFaqGetOneData, AdminFaqGetOneResponse, AdminFaqUpdateData, AdminFaqUpdateResponse, AdminFaqDeleteData, AdminFaqDeleteResponse, GasStationsListData, GasStationsListResponse, GasStationsCreateUserData, GasStationsCreateUserResponse, GasStationsMapData, GasStationsMapResponse, GasStationsListSubscriptionsResponse, GasStationsListFavoritesResponse, GasStationsGetOneData, GasStationsGetOneResponse, GasStationToggleFavoriteData, GasStationToggleFavoriteResponse, GasStationUpsertSubscriptionData, GasStationUpsertSubscriptionResponse, GasStationRemoveSubscriptionData, GasStationRemoveSubscriptionResponse, GasStationsSubmitReportData, GasStationsSubmitReportResponse, AdminGasStationsBulkScanData, AdminGasStationsBulkScanResponse, AdminGasStationsCreateData, AdminGasStationsCreateResponse, AdminGasStationsListResponse, AdminGasStationsGetOneData, AdminGasStationsGetOneResponse, AdminGasStationsUpdateData, AdminGasStationsUpdateResponse, AdminGasStationsDeleteData, AdminGasStationsDeleteResponse, AdminGasStationsReportsData, AdminGasStationsReportsResponse, SystemSettingsGetPublicResponse, AdminSystemSettingsGetResponse, AdminSystemSettingsUpdateData, AdminSystemSettingsUpdateResponse, AdminSystemSettingsGetByKeyData, AdminSystemSettingsGetByKeyResponse, HelpListServicesResponse, HelpQuoteData, HelpQuoteResponse, HelpGetActiveOrderResponse, HelpCreateOrderData, HelpCreateOrderResponse, HelpGetOrderData, HelpGetOrderResponse, HelpCancelOrderData, HelpCancelOrderResponse, SuperadminHelpOrdersMetricsResponse, SuperadminListHelpOrdersResponse, SuperadminGetHelpOrderData, SuperadminGetHelpOrderResponse, SuperadminUpdateHelpOrderData, SuperadminUpdateHelpOrderResponse, SuperadminUpdateHelpOrderStatusData, SuperadminUpdateHelpOrderStatusResponse, SuperadminCommentHelpOrderData, SuperadminCommentHelpOrderResponse, SuperadminNotifyHelpOrderData, SuperadminNotifyHelpOrderResponse, SuperadminListHelpServicesResponse, SuperadminCreateHelpServiceData, SuperadminCreateHelpServiceResponse, SuperadminUpdateHelpServiceData, SuperadminUpdateHelpServiceResponse, SuperadminDeleteHelpServiceData, SuperadminDeleteHelpServiceResponse, SuperadminListHelpExecutorsResponse, SuperadminCreateHelpExecutorData, SuperadminCreateHelpExecutorResponse, SuperadminUpdateHelpExecutorData, SuperadminUpdateHelpExecutorResponse, SuperadminDeleteHelpExecutorData, SuperadminDeleteHelpExecutorResponse } from './types.gen';

/**
 * Hello World
 * @returns unknown
 * @throws ApiError
 */
export const appGetHello = (): CancelablePromise<AppGetHelloResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api'
    });
};

/**
 * Health check endpoint
 * Проверка работоспособности API
 * @returns unknown
 * @throws ApiError
 */
export const appHealthCheck = (): CancelablePromise<AppHealthCheckResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/health'
    });
};

/**
 * Аутентификация пользователя
 * Вход в систему через email и пароль. Устанавливает HTTP-only cookie с JWT токеном.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AuthResponseDto Успешная авторизация
 * @throws ApiError
 */
export const authLogin = (data: AuthLoginData): CancelablePromise<AuthLoginResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/auth/login',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Невалидные данные',
            401: 'Неверный email или пароль',
            423: 'Аккаунт заблокирован',
            429: 'Превышено количество попыток входа'
        }
    });
};

/**
 * Выход из системы
 * Выход из системы. Удаляет HTTP-only cookie и добавляет токен в blacklist.
 * @returns LogoutResponseDto Успешный выход из системы
 * @throws ApiError
 */
export const authLogout = (): CancelablePromise<AuthLogoutResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/auth/logout',
        errors: {
            401: 'Токен недействителен или отсутствует'
        }
    });
};

/**
 * Получение информации о текущем пользователе
 * Возвращает информацию о текущем авторизованном пользователе.
 * @returns UserResponseDto Информация о текущем пользователе
 * @throws ApiError
 */
export const authGetCurrentUser = (): CancelablePromise<AuthGetCurrentUserResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/auth/me',
        errors: {
            401: 'Токен недействителен или отсутствует'
        }
    });
};

/**
 * Обновление токенов
 * Обновляет пару токенов (accessToken и refreshToken) используя действующий refreshToken. Старый refreshToken добавляется в blacklist.
 * @returns RefreshResponseDto Токены успешно обновлены
 * @throws ApiError
 */
export const authRefresh = (): CancelablePromise<AuthRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/auth/refresh',
        errors: {
            401: 'RefreshToken недействителен или истёк'
        }
    });
};

/**
 * Получение всех ролей
 * Возвращает список всех ролей в системе.
 * @returns Role Список ролей успешно получен
 * @throws ApiError
 */
export const rolesGetAll = (): CancelablePromise<RolesGetAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/roles'
    });
};

/**
 * Создание новой роли
 * Создает новую роль в системе.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Role Роль успешно создана
 * @throws ApiError
 */
export const rolesCreate = (data: RolesCreateData): CancelablePromise<RolesCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/roles',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Невалидные данные для создания роли'
        }
    });
};

/**
 * Получение роли по UUID
 * Возвращает роль по указанному UUID.
 * @param data The data for the request.
 * @param data.uuid UUID роли
 * @returns Role Роль успешно найдена
 * @throws ApiError
 */
export const rolesGetOne = (data: RolesGetOneData): CancelablePromise<RolesGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/roles/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            404: 'Роль не найдена'
        }
    });
};

/**
 * Обновление роли
 * Обновляет существующую роль по UUID.
 * @param data The data for the request.
 * @param data.uuid UUID роли для обновления
 * @param data.requestBody
 * @returns Role Роль успешно обновлена
 * @throws ApiError
 */
export const rolesUpdate = (data: RolesUpdateData): CancelablePromise<RolesUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/roles/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Невалидные данные для обновления роли',
            404: 'Роль не найдена'
        }
    });
};

/**
 * Удаление роли
 * Удаляет роль по указанному UUID.
 * @param data The data for the request.
 * @param data.uuid UUID роли для уда��ения
 * @returns unknown Роль успешно удалена
 * @throws ApiError
 */
export const rolesDelete = (data: RolesDeleteData): CancelablePromise<RolesDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/roles/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            404: 'Роль не найдена'
        }
    });
};

/**
 * Отправка одноразового кода по SMS
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Код отправлен
 * @throws ApiError
 */
export const clientAuthSendCode = (data: ClientAuthSendCodeData): CancelablePromise<ClientAuthSendCodeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/client-auth/send-code',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный формат телефона',
            429: 'Слишком часто'
        }
    });
};

/**
 * Вход по коду
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClientAuthResponseDto
 * @throws ApiError
 */
export const clientAuthLogin = (data: ClientAuthLoginData): CancelablePromise<ClientAuthLoginResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/client-auth/login',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный код / формат',
            410: 'Код истёк',
            429: 'Превышено количество попыток'
        }
    });
};

/**
 * Обновление пары токенов
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClientAuthResponseDto
 * @throws ApiError
 */
export const clientAuthRefresh = (data: ClientAuthRefreshData): CancelablePromise<ClientAuthRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/client-auth/refresh',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            401: 'Неверный или просроченный refresh токен'
        }
    });
};

/**
 * Регистрация анонимного пользователя
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClientAuthResponseDto
 * @throws ApiError
 */
export const clientAuthRegister = (data: ClientAuthRegisterData): CancelablePromise<ClientAuthRegisterResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/client-auth/register',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Установка номера телефона для авторизованного пользователя
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClientAuthResponseDto
 * @throws ApiError
 */
export const clientAuthSetPhone = (data: ClientAuthSetPhoneData): CancelablePromise<ClientAuthSetPhoneResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/client-auth/set-phone',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный код или телефон занят',
            401: 'Пользователь не авторизован',
            410: 'Код истёк'
        }
    });
};

/**
 * Отправка SMS кода для админа
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AdminSendCodeResponseDto Код отправлен
 * @throws ApiError
 */
export const adminAuthSendCode = (data: AdminAuthSendCodeData): CancelablePromise<AdminAuthSendCodeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin-auth/send-code',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный формат телефона',
            404: 'Пользователь с таким телефоном не найден или не является админом',
            429: 'Слишком частые запросы'
        }
    });
};

/**
 * Вход админа по SMS коду
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AdminAuthResponseDto Успешная авторизация
 * @throws ApiError
 */
export const adminAuthLogin = (data: AdminAuthLoginData): CancelablePromise<AdminAuthLoginResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin-auth/login',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный код или формат',
            401: 'Пользователь не является админом',
            410: 'Код истёк',
            429: 'Превышено количество попыток'
        }
    });
};

/**
 * Обмен одноразового кода impersonation на токены
 * Публичный endpoint. Код одноразовый, выдаётся суперадмином через POST /superadmin/service-centers/:uuid/impersonate.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AdminAuthResponseDto Токены успешно выданы
 * @throws ApiError
 */
export const adminAuthExchangeImpersonationCode = (data: AdminAuthExchangeImpersonationCodeData): CancelablePromise<AdminAuthExchangeImpersonationCodeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin-auth/exchange-impersonation-code',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            401: 'Код недействителен или уже использован'
        }
    });
};

/**
 * Получить данные текущего клиента
 * Возвращает профиль авторизованного клиента
 * @returns ClientResponseDto Данные клиента успешно получены
 * @throws ApiError
 */
export const clientGetMe = (): CancelablePromise<ClientGetMeResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/clients/me',
        errors: {
            401: 'Не авторизован',
            404: 'Клиент не найден'
        }
    });
};

/**
 * Обновить профиль клиента
 * Обновляет данные профиля авторизованного клиента
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClientResponseDto Профиль клиента успешно обновлен
 * @throws ApiError
 */
export const clientUpdateMe = (data: ClientUpdateMeData): CancelablePromise<ClientUpdateMeResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/clients/me',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            404: 'Клиент не найден'
        }
    });
};

/**
 * Запросить удаление аккаунта
 * Запрашивает удаление аккаунта клиента. На номер телефона клиента будет отправлен SMS код для подтверждения. После получения кода необходимо вызвать POST /clients/me/confirm-delete.
 * @returns unknown Код подтверждения отправлен
 * @throws ApiError
 */
export const clientRequestDeleteAccount = (): CancelablePromise<ClientRequestDeleteAccountResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/clients/me',
        errors: {
            401: 'Не авторизован',
            404: 'Клиент не найден',
            429: 'Слишком много запросов'
        }
    });
};

/**
 * Получить список автомобилей клиента
 * Возвращает все автомобили, принадлежащие авторизованному клиенту
 * @returns CarResponseDto Список автомобилей успешно получен
 * @throws ApiError
 */
export const clientListCars = (): CancelablePromise<ClientListCarsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/clients/me/cars',
        errors: {
            401: 'Не авторизован'
        }
    });
};

/**
 * Добавить автомобиль
 * Создает новый автомобиль для авторизованного клиента
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CarResponseDto Автомобиль успешно создан
 * @throws ApiError
 */
export const clientCreateCar = (data: ClientCreateCarData): CancelablePromise<ClientCreateCarResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/clients/me/cars',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован'
        }
    });
};

/**
 * Получить данные автомобиля
 * Возвращает информацию о конкретном автомобиле клиента
 * @param data The data for the request.
 * @param data.carUuid Уникальный идентификатор автомобиля
 * @returns CarResponseDto Данные автомобиля успешно получены
 * @throws ApiError
 */
export const clientGetCar = (data: ClientGetCarData): CancelablePromise<ClientGetCarResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/clients/me/cars/{car_uuid}',
        path: {
            car_uuid: data.carUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Автомобиль не принадлежит клиенту',
            404: 'Автомобиль не найден'
        }
    });
};

/**
 * Обновить данные автомобиля
 * Обновляет информацию об автомобиле клиента
 * @param data The data for the request.
 * @param data.carUuid Уникальный идентификатор автомобиля
 * @param data.requestBody
 * @returns CarResponseDto Данные автомобиля успешно обновлены
 * @throws ApiError
 */
export const clientUpdateCar = (data: ClientUpdateCarData): CancelablePromise<ClientUpdateCarResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/clients/me/cars/{car_uuid}',
        path: {
            car_uuid: data.carUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Автомобиль не принадлежит клиенту',
            404: 'Автомобиль не найден'
        }
    });
};

/**
 * Удалить автомобиль
 * Удаляет автомобиль из списка клиента
 * @param data The data for the request.
 * @param data.carUuid Уникальный идентификатор автомобиля
 * @returns void Автомобиль успешно удален
 * @throws ApiError
 */
export const clientDeleteCar = (data: ClientDeleteCarData): CancelablePromise<ClientDeleteCarResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/clients/me/cars/{car_uuid}',
        path: {
            car_uuid: data.carUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Автомобиль не принадлежит клиенту',
            404: 'Автомобиль не найден'
        }
    });
};

/**
 * Получить список бронирований клиента
 * Возвращает все бронирования авторизованного клиента
 * @returns unknown Список бронирований успешно получен
 * @throws ApiError
 */
export const clientListBookings = (): CancelablePromise<ClientListBookingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/clients/me/bookings',
        errors: {
            401: 'Не авторизован'
        }
    });
};

/**
 * Подтвердить удаление аккаунта
 * Подтверждает удаление персональных данных с помощью SMS кода. После подтверждения очищаются имя и email, удаляются сессии и FCM токены. Телефон сохраняется для повторного входа. История бронирований сохраняется.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void Персональные данные успешно удалены
 * @throws ApiError
 */
export const clientConfirmDeleteAccount = (data: ClientConfirmDeleteAccountData): CancelablePromise<ClientConfirmDeleteAccountResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/clients/me/confirm-delete',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный код подтверждения',
            401: 'Не авторизован',
            404: 'Клиент не найден',
            410: 'Код подтверждения истёк',
            429: 'Превышено количество попыток'
        }
    });
};

/**
 * Запросить удаление аккаунта по номеру телефона
 * Публичный эндпоинт. Отправляет SMS-код на номер телефона для подтверждения удаления персональных данных.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Запрос принят
 * @throws ApiError
 */
export const clientRequestDeleteAccountByPhone = (data: ClientRequestDeleteAccountByPhoneData): CancelablePromise<ClientRequestDeleteAccountByPhoneResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/clients/account-deletion/request',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный формат телефона',
            429: 'Слишком много запросов'
        }
    });
};

/**
 * Подтвердить удаление аккаунта по номеру телефона
 * Публичный эндпоинт. Подтверждает удаление персональных данных с помощью SMS-кода.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void Персональные данные удалены
 * @throws ApiError
 */
export const clientConfirmDeleteAccountByPhone = (data: ClientConfirmDeleteAccountByPhoneData): CancelablePromise<ClientConfirmDeleteAccountByPhoneResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/clients/account-deletion/confirm',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный код подтверждения',
            410: 'Код подтверждения истёк',
            429: 'Превышено количество попыток'
        }
    });
};

/**
 * Поиск клиентов по номеру телефона
 * Ищет клиентов по частичному или полному номеру телефона. Поиск регистронезависимый, без учета форматирования (только цифры). Требуется аутентификация админа.
 * @param data The data for the request.
 * @param data.phone Частичный или полный номер телефона для поиска (минимум 3 цифры)
 * @param data.limit Количество результатов
 * @returns ClientSearchResultDto Список найденных клиентов
 * @throws ApiError
 */
export const adminSearchClients = (data: AdminSearchClientsData): CancelablePromise<AdminSearchClientsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/clients/search',
        query: {
            phone: data.phone,
            limit: data.limit
        },
        errors: {
            400: 'Неверные параметры запроса',
            401: 'Не авторизован',
            403: 'Недостаточно прав (не админ)'
        }
    });
};

/**
 * Поиск или создание клиента по телефону
 * Ищет клиента по номеру телефона. Если не найден — создаёт нового. Опционально можно передать name: при создании сохраняется сразу, для существующего клиента обновляет имя. Требуется аутентификация админа.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AdminFindOrCreateClientResponseDto Клиент найден или создан
 * @throws ApiError
 */
export const adminFindOrCreateClient = (data: AdminFindOrCreateClientData): CancelablePromise<AdminFindOrCreateClientResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/clients/find-or-create',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный формат телефона',
            401: 'Не авторизован',
            403: 'Недостаточно прав (не админ)'
        }
    });
};

/**
 * Создание или обновление автомобиля клиента
 * Ищет автомобиль клиента по номеру. Если найден - обновляет данные. Если не найден - создает новый. Требуется аутентификация админа.
 * @param data The data for the request.
 * @param data.clientUuid UUID клиента
 * @param data.requestBody
 * @returns AdminCarResponseDto Автомобиль создан или обновлен
 * @throws ApiError
 */
export const adminCreateOrUpdateCar = (data: AdminCreateOrUpdateCarData): CancelablePromise<AdminCreateOrUpdateCarResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/clients/{client_uuid}/cars',
        path: {
            client_uuid: data.clientUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Недостаточно прав (не админ)',
            404: 'Клиент не найден'
        }
    });
};

/**
 * Список клиентов системы
 * Возвращает постраничный список всех клиентов приложения с возможностью поиска, фильтрации и сортировки. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.serviceCenterIds Список UUID сервисных центров через запятую. Оставляет клиентов, у которых есть бронирования в выбранных СЦ
 * @param data.filterTotalSpentLte Расходы за месяц ≤ значения (руб.)
 * @param data.filterTotalSpentGte Расходы за месяц ≥ значения (руб.)
 * @param data.filterBookingsCountLte Количество бронирований за месяц ≤ значения
 * @param data.filterBookingsCountGte Количество бронирований за месяц ≥ значения
 * @param data.q Поиск по имени, телефону или email клиента
 * @param data.sort Сортировка: поле или -поле для DESC. Пример: -totalSpent,created_at. Доступные поля: bookingsCount, totalSpent, created_at
 * @param data.limit Элементов на странице (по умолчанию 20, макс 100)
 * @param data.page Страница (по умолчанию 1)
 * @param data.year Год. Если передан вместе с month — метрики считаются за период
 * @param data.month Месяц (1-12). Если передан вместе с year — метрики считаются за период
 * @returns SuperadminClientListResponseDto Список клиентов успешно получен
 * @throws ApiError
 */
export const superadminListClients = (data: SuperadminListClientsData = {}): CancelablePromise<SuperadminListClientsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients',
        query: {
            serviceCenterIds: data.serviceCenterIds,
            'filter[totalSpent][lte]': data.filterTotalSpentLte,
            'filter[totalSpent][gte]': data.filterTotalSpentGte,
            'filter[bookingsCount][lte]': data.filterBookingsCountLte,
            'filter[bookingsCount][gte]': data.filterBookingsCountGte,
            q: data.q,
            sort: data.sort,
            limit: data.limit,
            page: data.page,
            year: data.year,
            month: data.month
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа'
        }
    });
};

/**
 * Сводные метрики по всем клиентам
 * Возвращает агрегированные метрики (бронирования, расходы) и данные для графиков по выбранному периоду. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.month Месяц (1-12). Передаётся при выборе месяца
 * @param data.year Год. Передаётся при выборе месяца или года
 * @param data.week Номер недели в году (1-53). Передаётся при выборе недели
 * @param data.serviceCenterIds Список UUID сервисных центров через запятую. Ограничивает клиентов, по которым считаются метрики
 * @param data.q Поиск по имени/телефону/email клиента — ограничивает выборку, по которой считаются метрики
 * @returns SuperadminClientSummaryDto Сводные метрики успешно получены
 * @throws ApiError
 */
export const superadminGetClientsSummary = (data: SuperadminGetClientsSummaryData = {}): CancelablePromise<SuperadminGetClientsSummaryResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients/summary',
        query: {
            month: data.month,
            year: data.year,
            week: data.week,
            serviceCenterIds: data.serviceCenterIds,
            q: data.q
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа'
        }
    });
};

/**
 * Агрегированные метрики по клиентам
 * Возвращает метрики по сгруппированным клиентам платформы. group_by: created_at_day|week|month, service_center_uuid. metrics: count, sum_bookings_count, sum_total_spent, avg_total_spent.
 * @param data The data for the request.
 * @param data.groupBy
 * @param data.metrics
 * @param data.limit
 * @returns GroupedResponseDto Сгруппированные метрики
 * @throws ApiError
 */
export const superadminGroupClients = (data: SuperadminGroupClientsData): CancelablePromise<SuperadminGroupClientsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients/grouped',
        query: {
            group_by: data.groupBy,
            metrics: data.metrics,
            limit: data.limit
        }
    });
};

/**
 * Получить клиента по UUID
 * Возвращает детальную информацию о клиенте, включая список его автомобилей. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID клиента
 * @returns SuperadminClientDetailDto Данные клиента успешно получены
 * @throws ApiError
 */
export const superadminGetClient = (data: SuperadminGetClientData): CancelablePromise<SuperadminGetClientResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Клиент не найден'
        }
    });
};

/**
 * Годовая статистика клиента
 * Возвращает агрегированные показатели клиента за год: бронирования, расходы, комиссия, % через приложение. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID клиента
 * @param data.year Год (2000–2100)
 * @returns ClientStatsResponseDto Статистика успешно получена
 * @throws ApiError
 */
export const superadminGetClientStats = (data: SuperadminGetClientStatsData): CancelablePromise<SuperadminGetClientStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients/{uuid}/stats',
        path: {
            uuid: data.uuid
        },
        query: {
            year: data.year
        },
        errors: {
            400: 'Некорректный год',
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Клиент не найден'
        }
    });
};

/**
 * История операций клиента
 * Возвращает постраничный список платежей и возвратов клиента. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID клиента
 * @param data.filterDateToEq Конец периода (ISO 8601)
 * @param data.filterDateFromEq Начало периода (ISO 8601)
 * @param data.filterPaymentMethodEq Метод оплаты
 * @param data.filterStatusEq Статус операции
 * @param data.filterTypeEq Тип операции
 * @param data.q Поиск по UUID бронирования
 * @param data.sort Сортировка: date, -date, amount, -amount
 * @param data.limit Элементов на странице
 * @param data.page Страница
 * @returns ClientTransactionsListResponseDto История операций успешно получена
 * @throws ApiError
 */
export const superadminGetClientTransactions = (data: SuperadminGetClientTransactionsData): CancelablePromise<SuperadminGetClientTransactionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients/{uuid}/transactions',
        path: {
            uuid: data.uuid
        },
        query: {
            'filter[date_to][eq]': data.filterDateToEq,
            'filter[date_from][eq]': data.filterDateFromEq,
            'filter[payment_method][eq]': data.filterPaymentMethodEq,
            'filter[status][eq]': data.filterStatusEq,
            'filter[type][eq]': data.filterTypeEq,
            q: data.q,
            sort: data.sort,
            limit: data.limit,
            page: data.page
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Клиент не найден'
        }
    });
};

/**
 * Бронирования клиента
 * Возвращает постраничный список бронирований клиента с фильтрацией и поиском. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID клиента
 * @param data.filterDateToEq Конец периода (ISO 8601)
 * @param data.filterDateFromEq Начало периода (ISO 8601)
 * @param data.filterPaymentStatusEq Статус оплаты
 * @param data.filterStatusEq Статус бронирования
 * @param data.q Поиск по названию услуги, СЦ, марке/модели авто
 * @param data.sort Сортировка: start_time, -start_time, total_cost, -total_cost, created_at, -created_at
 * @param data.limit Элементов на странице
 * @param data.page Страница
 * @returns ClientBookingsListResponseDto Список бронирований клиента успешно получен
 * @throws ApiError
 */
export const superadminGetClientBookings = (data: SuperadminGetClientBookingsData): CancelablePromise<SuperadminGetClientBookingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/clients/{uuid}/bookings',
        path: {
            uuid: data.uuid
        },
        query: {
            'filter[date_to][eq]': data.filterDateToEq,
            'filter[date_from][eq]': data.filterDateFromEq,
            'filter[payment_status][eq]': data.filterPaymentStatusEq,
            'filter[status][eq]': data.filterStatusEq,
            q: data.q,
            sort: data.sort,
            limit: data.limit,
            page: data.page
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Клиент не найден'
        }
    });
};

/**
 * Получить список сервисных центров
 * Возвращает список сервисных центров в указанном радиусе с возможностью фильтрации и сортировки
 * @param data The data for the request.
 * @param data.lat Широта местоположения пользователя
 * @param data.lon Долгота местоположения пользователя
 * @param data.radius Радиус поиска в метрах
 * @param data.category Категория услуг для фильтрации
 * @param data.search Поисковый запрос для фильтрации по названию или адресу сервисного центра
 * @param data.minRating Минимальный рейтинг сервисного центра
 * @param data.isOpenNow Фильтр по работающим в данный момент центрам
 * @param data.startPrice Минимальная цена услуги
 * @param data.endPrice Максимальная цена услуги
 * @param data.sortBy Критерий сортировки результатов
 * @param data.withFreeSlots Показывать только сервисные центры со свободными слотами (с учетом фильтров category)
 * @param data.businessType Фильтр по типу бизнеса сервисного центра
 * @param data.onlyFavorites Показывать только избранные сервисные центры
 * @returns ReducedServiceCenterResponseDto Список сервисных центров успешно получен
 * @throws ApiError
 */
export const serviceCenterList = (data: ServiceCenterListData = {}): CancelablePromise<ServiceCenterListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/service-centers',
        query: {
            lat: data.lat,
            lon: data.lon,
            radius: data.radius,
            category: data.category,
            search: data.search,
            min_rating: data.minRating,
            is_open_now: data.isOpenNow,
            startPrice: data.startPrice,
            endPrice: data.endPrice,
            sort_by: data.sortBy,
            withFreeSlots: data.withFreeSlots,
            businessType: data.businessType,
            onlyFavorites: data.onlyFavorites
        },
        errors: {
            400: 'Некорректные параметры запроса'
        }
    });
};

/**
 * Получить детальную информацию о сервисном центре
 * Возвращает полную информацию о сервисном центре по его идентификатору
 * @param data The data for the request.
 * @param data.uuid Уникальный идентификатор сервисного центра
 * @returns DetailedServiceCenterResponseDto Данные сервисного центра успешно получены
 * @throws ApiError
 */
export const serviceCenterGetOne = (data: ServiceCenterGetOneData): CancelablePromise<ServiceCenterGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/service-centers/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить доступные временные слоты
 * Возвращает список доступных временных слотов для записи на указанную дату и услугу
 * @param data The data for the request.
 * @param data.uuid Уникальный идентификатор сервисного центра
 * @param data.serviceUuid Уникальный идентификатор услуги
 * @param data.date Дата для поиска доступных слотов (используется если не указаны dateFrom/dateTo)
 * @param data.dateFrom Начальная дата диапазона для поиска слотов
 * @param data.dateTo Конечная дата диапазона для поиска слотов
 * @param data.additionalServiceUuids Список UUID дополнительных услуг для расчета общей длительности
 * @param data.serviceCenterPostUuid UUID поста сервисного центра для фильтрации слотов. Если указан - возвращаются слоты только для конкретного поста. Если не указан - слот считается свободным, если хотя бы один пост свободен
 * @param data.step Шаг расчёта слотов в минутах. По умолчанию 60 минут (1 час). Минимум 15, максимум 120 минут
 * @param data.isClient Флаг клиентского запроса. Если true - возвращаются только слоты постов с isAvailableForOnlineBooking=true. Если false или не указан - возвращаются все слоты (для админа)
 * @returns string Список доступных слотов успешно получен
 * @throws ApiError
 */
export const serviceCenterGetSlots = (data: ServiceCenterGetSlotsData): CancelablePromise<ServiceCenterGetSlotsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/service-centers/{uuid}/slots',
        path: {
            uuid: data.uuid
        },
        query: {
            date: data.date,
            dateFrom: data.dateFrom,
            dateTo: data.dateTo,
            service_uuid: data.serviceUuid,
            additional_service_uuids: data.additionalServiceUuids,
            service_center_post_uuid: data.serviceCenterPostUuid,
            step: data.step,
            isClient: data.isClient
        },
        errors: {
            400: 'Некорректные параметры запроса',
            404: 'Сервисный центр или услуга не найдены'
        }
    });
};

/**
 * Добавить/удалить сервисный центр из избранного
 * Переключает статус сервисного центра в избранном пользователя
 * @param data The data for the request.
 * @param data.uuid Уникальный идентификатор сервисного центра
 * @returns unknown Статус избранного успешно изменен
 * @throws ApiError
 */
export const serviceCenterToggleFavorite = (data: ServiceCenterToggleFavoriteData): CancelablePromise<ServiceCenterToggleFavoriteResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/service-centers/{uuid}/favorite',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Пользователь не авторизован',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить список постов сервисного центра
 * Возвращает список всех активных постов сервисного центра, отсортированных по дате создания
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns ServiceCenterPostsListResponseDto Список постов успешно получен
 * @throws ApiError
 */
export const adminGetServiceCenterPosts = (data: AdminGetServiceCenterPostsData): CancelablePromise<AdminGetServiceCenterPostsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/posts',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Создать новый пост
 * Создает новый пост для сервисного центра. Каждый пост может обрабатывать одно бронирование в единицу времени.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns CreatePostResponseDto Пост успешно создан
 * @throws ApiError
 */
export const adminCreateServiceCenterPost = (data: AdminCreateServiceCenterPostData): CancelablePromise<AdminCreateServiceCenterPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/service-centers/{serviceCenterUuid}/posts',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Удалить пост
 * Удаляет пост сервисного центра (soft delete). Нельзя удалить последний пост или пост с активными бронированиями.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.postUuid UUID поста для удаления
 * @returns DeletePostResponseDto Пост успешно удален
 * @throws ApiError
 */
export const adminDeleteServiceCenterPost = (data: AdminDeleteServiceCenterPostData): CancelablePromise<AdminDeleteServiceCenterPostResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/service-centers/{serviceCenterUuid}/posts/{postUuid}',
        path: {
            serviceCenterUuid: data.serviceCenterUuid,
            postUuid: data.postUuid
        },
        errors: {
            400: 'Невозможно удалить последний пост или пост с активными бронированиями',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр или пост не найден'
        }
    });
};

/**
 * Обновить параметры поста
 * Обновляет параметры поста, например доступность для онлайн записи. Недоступные посты не будут учитываться при поиске свободных слотов.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.postUuid UUID поста
 * @param data.requestBody
 * @returns UpdatePostResponseDto Пост успешно обновлен
 * @throws ApiError
 */
export const adminUpdateServiceCenterPost = (data: AdminUpdateServiceCenterPostData): CancelablePromise<AdminUpdateServiceCenterPostResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/service-centers/{serviceCenterUuid}/posts/{postUuid}',
        path: {
            serviceCenterUuid: data.serviceCenterUuid,
            postUuid: data.postUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр или пост не найден'
        }
    });
};

/**
 * Получить юридические данные сервисного центра
 * Возвращает текущее состояние всех юридических и банковских полей, необходимых для регистрации партнёра в T-Bank MultiSplit.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns LegalDataResponseDto Юридические данные успешно получены
 * @throws ApiError
 */
export const adminGetServiceCenterLegalData = (data: AdminGetServiceCenterLegalDataData): CancelablePromise<AdminGetServiceCenterLegalDataResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/legal-data',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            403: 'Нет доступа к данному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Сохранить юридические данные сервисного центра
 * Поэтапное сохранение юридических и банковских данных, необходимых для регистрации партнёра в T-Bank MultiSplit. Все поля опциональны — передавайте только те, которые нужно обновить на текущем шаге. Каждое переданное поле валидируется независимо.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.requestBody
 * @returns LegalDataResponseDto Данные успешно сохранены
 * @throws ApiError
 */
export const adminUpdateServiceCenterLegalData = (data: AdminUpdateServiceCenterLegalDataData): CancelablePromise<AdminUpdateServiceCenterLegalDataResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/service-centers/{serviceCenterUuid}/legal-data',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Валидационная ошибка в одном или нескольких полях',
            403: 'Нет доступа к данному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить данные контрагента сервисного центра
 * Возвращает текущее состояние данных контрагента (ФИО, ИНН, паспорт и т.д.).
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown Данные контрагента успешно получены
 * @throws ApiError
 */
export const adminGetServiceCenterContractorData = (data: AdminGetServiceCenterContractorDataData): CancelablePromise<AdminGetServiceCenterContractorDataResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/contractor-data',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            403: 'Нет доступа к данному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Сохранить данные контрагента сервисного центра
 * Поэтапное сохранение данных контрагента. Все поля опциональны — передавайте только те, которые нужно обновить.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.requestBody
 * @returns unknown Данные контрагента успешно сохранены
 * @throws ApiError
 */
export const adminUpdateServiceCenterContractorData = (data: AdminUpdateServiceCenterContractorDataData): CancelablePromise<AdminUpdateServiceCenterContractorDataResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/service-centers/{serviceCenterUuid}/contractor-data',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Валидационная ошибка в одном или нескольких полях',
            403: 'Нет доступа к данному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить список банков-участников СБП
 * Возвращает статический список основных банков-участников СБП (НСПК). MemberId из ответа сохраняется в поле sbp_member_id через PATCH /contractor-data. Выбирать нужно банк, в котором самозанятый зарегистрировал свой номер телефона в СБП.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown Список банков СБП
 * @throws ApiError
 */
export const adminGetSbpBanks = (data: AdminGetSbpBanksData): CancelablePromise<AdminGetSbpBanksResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/contractor-data/sbp-banks',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        }
    });
};

/**
 * Сгенерировать PDF-контракт (лист акцепта)
 * Генерирует PDF-документ «Лист акцепта к Оферте» на основании заполненных данных контрагента и юридических данных. Если данных недостаточно — возвращает 400 со списком незаполненных полей.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown PDF-контракт успешно сгенерирован
 * @throws ApiError
 */
export const adminGenerateContract = (data: AdminGenerateContractData): CancelablePromise<AdminGenerateContractResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/service-centers/{serviceCenterUuid}/contractor-data/contract',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            400: 'Недостаточно данных для генерации контракта',
            403: 'Нет доступа к данному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Скачать последний сгенерированный PDF-контракт
 * Возвращает последний сохранённый PDF-контракт для данного сервисного центра. Если контракт ещё не был сгенерирован — возвращает 404.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown PDF-контракт успешно возвращён
 * @throws ApiError
 */
export const adminDownloadContract = (data: AdminDownloadContractData): CancelablePromise<AdminDownloadContractResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/contractor-data/contract',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            403: 'Нет доступа к данному сервисному центру',
            404: 'Контракт ещё не сгенерирован'
        }
    });
};

/**
 * Получить ссылку на PDF-контракт
 * Возвращает URL для скачивания последнего сохранённого PDF-контракта. Если контракт ещё не был сгенерирован — возвращает 404.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown Ссылка на контракт успешно получена
 * @throws ApiError
 */
export const adminGetContractLink = (data: AdminGetContractLinkData): CancelablePromise<AdminGetContractLinkResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/contractor-data/contract/link',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            403: 'Нет доступа к данному сервисному центру',
            404: 'Контракт ещё не сгенерирован'
        }
    });
};

/**
 * Зарегистрировать сервисный центр как точку партнёра в Т-Банке
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown Точка успешно зарегистрирована в Т-Банке
 * @throws ApiError
 */
export const adminRegisterServiceCenterInTBank = (data: AdminRegisterServiceCenterInTBankData): CancelablePromise<AdminRegisterServiceCenterInTBankResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/service-centers/{serviceCenterUuid}/tbank-registration',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            400: 'Не заполнены обязательные юридические данные',
            409: 'Точка уже зарегистрирована в Т-Банке',
            502: 'Ошибка T-Bank API'
        }
    });
};

/**
 * Получить статус регистрации сервисного центра в Т-Банке
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown Статус регистрации
 * @throws ApiError
 */
export const adminGetServiceCenterTBankRegistrationStatus = (data: AdminGetServiceCenterTBankRegistrationStatusData): CancelablePromise<AdminGetServiceCenterTBankRegistrationStatusResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{serviceCenterUuid}/tbank-registration/status',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        }
    });
};

/**
 * Получить список всех сервисных центров
 * Возвращает список сервисных центров с пагинацией, фильтрацией и сортировкой. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.filterRatingLte Рейтинг ≤ значения
 * @param data.filterRatingGte Рейтинг ≥ значения
 * @param data.filterPendingPayoutLte Баланс к выплате ≤ значения (руб.)
 * @param data.filterPendingPayoutGte Баланс к выплате ≥ значения (руб.)
 * @param data.filterCommissionLte Комиссия за месяц ≤ значения (руб.)
 * @param data.filterCommissionGte Комиссия за месяц ≥ значения (руб.)
 * @param data.filterRevenueLte Выручка за месяц ≤ значения (руб.)
 * @param data.filterRevenueGte Выручка за месяц ≥ значения (руб.)
 * @param data.filterBookingsCountLte Количество бронирований за месяц ≤ значения
 * @param data.filterBookingsCountGte Количество бронирований за месяц ≥ значения
 * @param data.filterStatusEq Фильтр по статусу публикации
 * @param data.q Поиск по названию или адресу сервисного центра
 * @param data.sort Сортировка: поле или -поле для DESC. Пример: -revenue,created_at. Доступные поля: bookingsCount, rating, revenue, commission, pendingPayout, created_at
 * @param data.limit Элементов на странице (по умолчанию 20, макс 100)
 * @param data.page Страница (по умолчанию 1)
 * @param data.year Год. Если не передан — метрики возвращаются нулями
 * @param data.month Месяц (1-12). Если не передан — метрики возвращаются нулями
 * @returns SuperadminServiceCenterListResponseDto Список сервисных центров успешно получен
 * @throws ApiError
 */
export const superadminListServiceCenters = (data: SuperadminListServiceCentersData = {}): CancelablePromise<SuperadminListServiceCentersResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers',
        query: {
            'filter[rating][lte]': data.filterRatingLte,
            'filter[rating][gte]': data.filterRatingGte,
            'filter[pendingPayout][lte]': data.filterPendingPayoutLte,
            'filter[pendingPayout][gte]': data.filterPendingPayoutGte,
            'filter[commission][lte]': data.filterCommissionLte,
            'filter[commission][gte]': data.filterCommissionGte,
            'filter[revenue][lte]': data.filterRevenueLte,
            'filter[revenue][gte]': data.filterRevenueGte,
            'filter[bookingsCount][lte]': data.filterBookingsCountLte,
            'filter[bookingsCount][gte]': data.filterBookingsCountGte,
            'filter[status][eq]': data.filterStatusEq,
            q: data.q,
            sort: data.sort,
            limit: data.limit,
            page: data.page,
            year: data.year,
            month: data.month
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа'
        }
    });
};

/**
 * Создать новый сервисный центр
 * Создает новый сервисный центр и автоматически создает для него проект. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Сервисный центр успешно создан
 * @throws ApiError
 */
export const superadminCreateServiceCenter = (data: SuperadminCreateServiceCenterData): CancelablePromise<SuperadminCreateServiceCenterResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/service-centers',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Нет прав доступа'
        }
    });
};

/**
 * Сводные метрики по всем сервисным центрам
 * Возвращает агрегированные метрики (бронирования, выручка, комиссия) и данные для графиков по выбранному периоду. Поддерживает те же фильтры, что и список СЦ. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.month Месяц (1-12). Передаётся при выборе месяца
 * @param data.year Год. Передаётся при выборе месяца или года
 * @param data.week Номер недели в году (1-53). Передаётся при выборе недели
 * @param data.filterPendingPayoutLte Баланс к выплате ≤ значения (руб.)
 * @param data.filterPendingPayoutGte Баланс к выплате ≥ значения (руб.)
 * @param data.filterCommissionLte Комиссия за период ≤ значения (руб.)
 * @param data.filterCommissionGte Комиссия за период ≥ значения (руб.)
 * @param data.filterRevenueLte Выручка за период ≤ значения (руб.)
 * @param data.filterRevenueGte Выручка за период ≥ значения (руб.)
 * @param data.filterRatingLte Рейтинг ≤ значения
 * @param data.filterRatingGte Рейтинг ≥ значения
 * @param data.filterStatusEq Фильтр по статусу публикации
 * @param data.q Поиск по названию СЦ — ограничивает выборку, по которой считаются метрики
 * @returns SuperadminServiceCenterSummaryDto Сводные метрики успешно получены
 * @throws ApiError
 */
export const superadminGetServiceCentersSummary = (data: SuperadminGetServiceCentersSummaryData = {}): CancelablePromise<SuperadminGetServiceCentersSummaryResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/summary',
        query: {
            month: data.month,
            year: data.year,
            week: data.week,
            'filter[pendingPayout][lte]': data.filterPendingPayoutLte,
            'filter[pendingPayout][gte]': data.filterPendingPayoutGte,
            'filter[commission][lte]': data.filterCommissionLte,
            'filter[commission][gte]': data.filterCommissionGte,
            'filter[revenue][lte]': data.filterRevenueLte,
            'filter[revenue][gte]': data.filterRevenueGte,
            'filter[rating][lte]': data.filterRatingLte,
            'filter[rating][gte]': data.filterRatingGte,
            'filter[status][eq]': data.filterStatusEq,
            q: data.q
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа'
        }
    });
};

/**
 * KPI-метрики и графики сервисного центра
 * Возвращает данные для KPI-карточек (оборот, бронирования, средний чек, комиссия) и графиков за указанный год. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @param data.year Год, за который считаются метрики (2020–2100)
 * @returns ScStatsResponseDto KPI-метрики успешно получены
 * @throws ApiError
 */
export const superadminGetServiceCenterStats = (data: SuperadminGetServiceCenterStatsData): CancelablePromise<SuperadminGetServiceCenterStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{uuid}/stats',
        path: {
            uuid: data.uuid
        },
        query: {
            year: data.year
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Создать одноразовый код для входа в панель СЦ
 * Выдаёт одноразовый код (TTL 60с). Service-admin обменивает его на JWT с контекстом выбранного сервисного центра.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @returns ImpersonationCodeResponseDto Код успешно создан
 * @throws ApiError
 */
export const superadminImpersonateServiceCenter = (data: SuperadminImpersonateServiceCenterData): CancelablePromise<SuperadminImpersonateServiceCenterResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/service-centers/{uuid}/impersonate',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить сервисный центр по UUID
 * Возвращает детальную информацию о сервисном центре, включая postsCount и businessTypes[]. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @returns SuperadminServiceCenterDetailDto Данные сервисного центра успешно получены
 * @throws ApiError
 */
export const superadminGetServiceCenter = (data: SuperadminGetServiceCenterData): CancelablePromise<SuperadminGetServiceCenterResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Редактировать сервисный центр
 * Частичное обновление данных сервисного центра. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @param data.requestBody
 * @returns unknown Сервисный центр успешно обновлён
 * @throws ApiError
 */
export const superadminUpdateServiceCenter = (data: SuperadminUpdateServiceCenterData): CancelablePromise<SuperadminUpdateServiceCenterResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/superadmin/service-centers/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Удалить сервисный центр
 * Мягкое удаление сервисного центра (soft delete). Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @returns unknown Сервисный центр успешно удален
 * @throws ApiError
 */
export const superadminDeleteServiceCenter = (data: SuperadminDeleteServiceCenterData): CancelablePromise<SuperadminDeleteServiceCenterResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/superadmin/service-centers/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * История операций сервисного центра
 * Возвращает историю платежей и выплат по конкретному СЦ с пагинацией и фильтрами. Объединяет payments и payouts через UNION ALL.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @param data.sort Сортировка: поле или -поле для DESC. Доступные поля: date, amount
 * @param data.filterDateToEq Дата окончания периода (ISO 8601)
 * @param data.filterDateFromEq Дата начала периода (ISO 8601)
 * @param data.filterPaymentMethodEq Фильтр по методу оплаты (только для платежей)
 * @param data.filterStatusEq Фильтр по статусу
 * @param data.filterTypeEq Фильтр по типу операции
 * @param data.q Поиск по описанию операции или UUID бронирования
 * @param data.limit Элементов на странице (по умолчанию 20)
 * @param data.page Страница (по умолчанию 1)
 * @returns TransactionsListResponseDto История операций успешно получена
 * @throws ApiError
 */
export const superadminGetServiceCenterTransactions = (data: SuperadminGetServiceCenterTransactionsData): CancelablePromise<SuperadminGetServiceCenterTransactionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{uuid}/transactions',
        path: {
            uuid: data.uuid
        },
        query: {
            sort: data.sort,
            'filter[date_to][eq]': data.filterDateToEq,
            'filter[date_from][eq]': data.filterDateFromEq,
            'filter[payment_method][eq]': data.filterPaymentMethodEq,
            'filter[status][eq]': data.filterStatusEq,
            'filter[type][eq]': data.filterTypeEq,
            q: data.q,
            limit: data.limit,
            page: data.page
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Бронирования сервисного центра
 * Возвращает список бронирований конкретного СЦ с пагинацией и фильтрами. Включает вложенные объекты client, service, car.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @param data.filterDateToEq Конец периода (ISO 8601)
 * @param data.filterDateFromEq Начало периода (ISO 8601)
 * @param data.filterPaymentStatusEq Фильтр по статусу оплаты
 * @param data.filterStatusEq Фильтр по статусу бронирования
 * @param data.q Поиск по имени/телефону клиента, названию услуги
 * @param data.sort Сортировка: поле или -поле для DESC. Доступные поля: start_time, total_cost, created_at, status
 * @param data.limit Элементов на странице (по умолчанию 20)
 * @param data.page Страница (по умолчанию 1)
 * @returns BookingsListResponseDto Список бронирований успешно получен
 * @throws ApiError
 */
export const superadminGetServiceCenterBookings = (data: SuperadminGetServiceCenterBookingsData): CancelablePromise<SuperadminGetServiceCenterBookingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{uuid}/bookings',
        path: {
            uuid: data.uuid
        },
        query: {
            'filter[date_to][eq]': data.filterDateToEq,
            'filter[date_from][eq]': data.filterDateFromEq,
            'filter[payment_status][eq]': data.filterPaymentStatusEq,
            'filter[status][eq]': data.filterStatusEq,
            q: data.q,
            sort: data.sort,
            limit: data.limit,
            page: data.page
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * История выплат сервисного центра
 * Возвращает историю выплат и текущий баланс к выплате для конкретного СЦ. Ответ включает pendingPayout и lastPayoutDate помимо стандартной пагинации.
 * @param data The data for the request.
 * @param data.uuid UUID сервисного центра
 * @param data.filterDateToEq Конец периода (ISO 8601)
 * @param data.filterDateFromEq Начало периода (ISO 8601)
 * @param data.filterStatusEq Фильтр по статусу выплаты
 * @param data.limit Элементов на странице (по умолчанию 20)
 * @param data.page Страница (по умолчанию 1)
 * @returns PayoutsListResponseDto История выплат успешно получена
 * @throws ApiError
 */
export const superadminGetServiceCenterPayouts = (data: SuperadminGetServiceCenterPayoutsData): CancelablePromise<SuperadminGetServiceCenterPayoutsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{uuid}/payouts',
        path: {
            uuid: data.uuid
        },
        query: {
            'filter[date_to][eq]': data.filterDateToEq,
            'filter[date_from][eq]': data.filterDateFromEq,
            'filter[status][eq]': data.filterStatusEq,
            limit: data.limit,
            page: data.page
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить список администраторов сервисного центра
 * Возвращает список всех администраторов указанного сервисного центра. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns unknown Список администраторов успешно получен
 * @throws ApiError
 */
export const superadminListServiceCenterAdmins = (data: SuperadminListServiceCenterAdminsData): CancelablePromise<SuperadminListServiceCenterAdminsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{serviceCenterUuid}/admins',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Создать администратора сервисного центра
 * Создает нового пользователя и назначает его администратором указанного сервисного центра со всеми доступными правами. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.requestBody
 * @returns unknown Администратор успешно создан
 * @throws ApiError
 */
export const superadminCreateServiceCenterAdmin = (data: SuperadminCreateServiceCenterAdminData): CancelablePromise<SuperadminCreateServiceCenterAdminResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/service-centers/{serviceCenterUuid}/admins',
        path: {
            serviceCenterUuid: data.serviceCenterUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр не найден',
            409: 'Пользователь с таким email или телефоном уже существует'
        }
    });
};

/**
 * Получить администратора по UUID
 * Возвращает информацию об администраторе сервисного центра. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.adminUuid UUID администратора
 * @returns unknown Данные администратора успешно получены
 * @throws ApiError
 */
export const superadminGetServiceCenterAdmin = (data: SuperadminGetServiceCenterAdminData): CancelablePromise<SuperadminGetServiceCenterAdminResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/service-centers/{serviceCenterUuid}/admins/{adminUuid}',
        path: {
            serviceCenterUuid: data.serviceCenterUuid,
            adminUuid: data.adminUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр или администратор не найден'
        }
    });
};

/**
 * Редактировать администратора сервисного центра
 * Частичное обновление данных администратора. Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.adminUuid UUID администратора
 * @param data.requestBody
 * @returns unknown Администратор успешно обновлён
 * @throws ApiError
 */
export const superadminUpdateServiceCenterAdmin = (data: SuperadminUpdateServiceCenterAdminData): CancelablePromise<SuperadminUpdateServiceCenterAdminResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/superadmin/service-centers/{serviceCenterUuid}/admins/{adminUuid}',
        path: {
            serviceCenterUuid: data.serviceCenterUuid,
            adminUuid: data.adminUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр или администратор не найден',
            409: 'Пользователь с таким email или телефоном уже существует'
        }
    });
};

/**
 * Удалить администратора сервисного центра
 * Мягкое удаление администратора (soft delete). Доступно только суперадминам.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.adminUuid UUID администратора
 * @returns unknown Администратор успешно удален
 * @throws ApiError
 */
export const superadminDeleteServiceCenterAdmin = (data: SuperadminDeleteServiceCenterAdminData): CancelablePromise<SuperadminDeleteServiceCenterAdminResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/superadmin/service-centers/{serviceCenterUuid}/admins/{adminUuid}',
        path: {
            serviceCenterUuid: data.serviceCenterUuid,
            adminUuid: data.adminUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сервисный центр или администратор не найден'
        }
    });
};

/**
 * Детальная информация о выплате
 * Возвращает информацию о конкретной выплате, связанном платеже, бронировании и сервисном центре.
 * @param data The data for the request.
 * @param data.uuid UUID выплаты
 * @returns SuperadminPayoutDetailResponseDto Детали выплаты
 * @throws ApiError
 */
export const superadminGetPayoutDetail = (data: SuperadminGetPayoutDetailData): CancelablePromise<SuperadminGetPayoutDetailResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/payouts/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Выплата не найдена'
        }
    });
};

/**
 * Шаг 1: запрос выплаты контрагентам
 * Принимает список контрагентов и суммы.
 * Бэкенд **верифицирует** переданные суммы — пересчитывает реальную задолженность для каждого СЦ с момента прошлой выплаты.
 * После проверки создаёт сессию выплаты и отправляет SMS-код на телефон суперадмина.
 * Банковский запрос на этом шаге НЕ формируется.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PayoutRequestResponseDto Сессия создана, SMS-код отправлен
 * @throws ApiError
 */
export const superadminPayoutRequest = (data: SuperadminPayoutRequestData): CancelablePromise<SuperadminPayoutRequestResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/payouts/request',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные запроса',
            401: 'Не авторизован',
            403: 'Нет прав доступа'
        }
    });
};

/**
 * Шаг 2: подтверждение выплаты через SMS-код
 * Принимает sessionId и SMS-код.
 * После успешной проверки формирует запросы в T-Bank для каждого контрагента из сессии.
 * Сессия действительна ограниченное время (см. expiresAt в ответе /request).
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PayoutConfirmResponseDto Выплаты успешно инициированы
 * @throws ApiError
 */
export const superadminPayoutConfirm = (data: SuperadminPayoutConfirmData): CancelablePromise<SuperadminPayoutConfirmResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/payouts/confirm',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Неверный SMS-код',
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Сессия не найдена',
            410: 'Сессия истекла'
        }
    });
};

/**
 * Получить все настройки времени работы
 * Получить регулярное расписание и специальные даты для сервисного центра
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.type Фильтр по типу расписания
 * @param data.month Фильтр по месяцу для специальных дат (формат YYYY-MM)
 * @returns OperatingHoursListResponseDto Список настроек времени работы
 * @throws ApiError
 */
export const operatingHoursGetAll = (data: OperatingHoursGetAllData): CancelablePromise<OperatingHoursGetAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/service-centers/{service_center_uuid}/operating-hours',
        path: {
            service_center_uuid: data.serviceCenterUuid
        },
        query: {
            type: data.type,
            month: data.month
        },
        errors: {
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Обновить регулярное расписание
 * Обновить расписание работы на все дни недели
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.requestBody
 * @returns OperatingHoursResponseDto Регулярное расписание обновлено
 * @throws ApiError
 */
export const operatingHoursUpdateRegular = (data: OperatingHoursUpdateRegularData): CancelablePromise<OperatingHoursUpdateRegularResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/admin/service-centers/{service_center_uuid}/operating-hours/regular',
        path: {
            service_center_uuid: data.serviceCenterUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Сервисный центр не найден',
            409: 'Невозможно изменить расписание: найдены подтвержденные заказы'
        }
    });
};

/**
 * Добавить специальную дату
 * Добавить праздник, выходной или сокращенный день
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.requestBody
 * @returns OperatingHoursResponseDto Специальная дата добавлена
 * @throws ApiError
 */
export const operatingHoursCreateSpecial = (data: OperatingHoursCreateSpecialData): CancelablePromise<OperatingHoursCreateSpecialResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/service-centers/{service_center_uuid}/operating-hours/special',
        path: {
            service_center_uuid: data.serviceCenterUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Сервисный центр не найден',
            409: 'Невозможно изменить расписание: найдены подтвержденные заказы'
        }
    });
};

/**
 * Обновить конкретную запись
 * Обновить существующую настройку времени работы
 * @param data The data for the request.
 * @param data.uuid UUID записи времени работы
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.requestBody
 * @returns OperatingHoursResponseDto Запись обновлена
 * @throws ApiError
 */
export const operatingHoursUpdate = (data: OperatingHoursUpdateData): CancelablePromise<OperatingHoursUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/service-centers/{service_center_uuid}/operating-hours/{uuid}',
        path: {
            uuid: data.uuid,
            service_center_uuid: data.serviceCenterUuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Запись не найдена',
            409: 'Невозможно изменить расписание: найдены подтвержденные заказы'
        }
    });
};

/**
 * Удалить специальную дату
 * Удалить настройку времени работы
 * @param data The data for the request.
 * @param data.uuid UUID записи времени работы
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns void Запись удалена
 * @throws ApiError
 */
export const operatingHoursDelete = (data: OperatingHoursDeleteData): CancelablePromise<OperatingHoursDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/service-centers/{service_center_uuid}/operating-hours/{uuid}',
        path: {
            uuid: data.uuid,
            service_center_uuid: data.serviceCenterUuid
        },
        errors: {
            404: 'Запись не найдена'
        }
    });
};

/**
 * Редирект после успешной оплаты T-Bank
 * Эндпоинт для SuccessURL T-Bank. WebView перехватывает этот редирект для определения результата оплаты.
 * @param data The data for the request.
 * @param data.paymentUuid
 * @param data.paymentUuid
 * @param data.paymentId
 * @returns unknown Оплата успешна
 * @throws ApiError
 */
export const paymentsControllerPaymentSuccess = (data: PaymentsControllerPaymentSuccessData): CancelablePromise<PaymentsControllerPaymentSuccessResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/payments/success',
        query: {
            payment_uuid: data.paymentUuid,
            paymentUuid: data.paymentUuid,
            paymentId: data.paymentId
        }
    });
};

/**
 * Редирект после неудачной оплаты T-Bank
 * Эндпоинт для FailURL T-Bank. WebView перехватывает этот редирект для определения ошибки оплаты.
 * @param data The data for the request.
 * @param data.errorCode
 * @param data.errorCode
 * @param data.code
 * @param data.message
 * @param data.message
 * @param data.error
 * @returns unknown Оплата не удалась
 * @throws ApiError
 */
export const paymentsControllerPaymentFail = (data: PaymentsControllerPaymentFailData): CancelablePromise<PaymentsControllerPaymentFailResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/payments/fail',
        query: {
            ErrorCode: data.errorCode,
            errorCode: data.errorCode,
            code: data.code,
            Message: data.message,
            message: data.message,
            error: data.error
        }
    });
};

/**
 * Webhook для получения уведомлений от T-Bank
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Webhook обработан
 * @throws ApiError
 */
export const paymentsControllerHandleTBankWebhook = (data: PaymentsControllerHandleTBankWebhookData): CancelablePromise<PaymentsControllerHandleTBankWebhookResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/payments/tbank/webhook',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные или невалидная подпись',
            404: 'Платеж не найден'
        }
    });
};

/**
 * Получить все платежи (для админки)
 * @returns PaymentResponseDto Список всех платежей
 * @throws ApiError
 */
export const paymentsControllerGetAllPayments = (): CancelablePromise<PaymentsControllerGetAllPaymentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/payments'
    });
};

/**
 * Инициализация платежа для бронирования
 * @param data The data for the request.
 * @param data.requestBody
 * @returns InitPaymentResponseDto Платеж инициализирован успешно
 * @throws ApiError
 */
export const paymentsControllerInitPayment = (data: PaymentsControllerInitPaymentData): CancelablePromise<PaymentsControllerInitPaymentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/payments/init',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            404: 'Бронирование не найдено'
        }
    });
};

/**
 * Получение статуса платежа
 * @param data The data for the request.
 * @param data.uuid
 * @returns PaymentStatusResponseDto Статус платежа
 * @throws ApiError
 */
export const paymentsControllerGetPaymentStatus = (data: PaymentsControllerGetPaymentStatusData): CancelablePromise<PaymentsControllerGetPaymentStatusResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/payments/{uuid}/status',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа к этому платежу',
            404: 'Платеж не найден'
        }
    });
};

/**
 * Отмена/возврат платежа (только для админов)
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns CancelPaymentResponseDto Платеж отменен/возвращен
 * @throws ApiError
 */
export const paymentsControllerCancelPayment = (data: PaymentsControllerCancelPaymentData): CancelablePromise<PaymentsControllerCancelPaymentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/payments/{uuid}/cancel',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            403: 'Недостаточно прав',
            404: 'Платеж не найден'
        }
    });
};

/**
 * Агрегированные метрики по платежам
 * Возвращает метрики по сгруппированным платежам платформы. group_by: status, payment_method, service_center_uuid, currency, paid_at_day|week|month. metrics: count, sum_amount, avg_amount.
 * @param data The data for the request.
 * @param data.groupBy
 * @param data.metrics
 * @param data.limit
 * @returns GroupedResponseDto Сгруппированные метрики
 * @throws ApiError
 */
export const superadminGroupPayments = (data: SuperadminGroupPaymentsData): CancelablePromise<SuperadminGroupPaymentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/payments/grouped',
        query: {
            group_by: data.groupBy,
            metrics: data.metrics,
            limit: data.limit
        }
    });
};

/**
 * Список всех платежей платформы
 * Возвращает постраничный список платежей по всем сервисным центрам с фильтрацией, сортировкой и поиском.
 * @returns unknown Список платежей
 * @throws ApiError
 */
export const superadminListPayments = (): CancelablePromise<SuperadminListPaymentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/payments'
    });
};

/**
 * Получить историю событий платежа
 * Возвращает хронологический список всех событий по платежу (webhook, init, confirm, cancel). Доступно суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID платежа
 * @returns PaymentEventsResponseDto История событий платежа
 * @throws ApiError
 */
export const superadminGetPaymentEvents = (data: SuperadminGetPaymentEventsData): CancelablePromise<SuperadminGetPaymentEventsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/payments/{uuid}/events',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Платёж не найден'
        }
    });
};

/**
 * Получить детальную информацию о платеже
 * Возвращает полную информацию о платеже, включая данные из T-Bank GetState, чек и связанное бронирование. Доступно суперадминам.
 * @param data The data for the request.
 * @param data.uuid UUID платежа
 * @returns SuperadminPaymentDetailResponseDto Детали платежа
 * @throws ApiError
 */
export const superadminGetPaymentDetail = (data: SuperadminGetPaymentDetailData): CancelablePromise<SuperadminGetPaymentDetailResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/payments/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Платёж не найден'
        }
    });
};

/**
 * Запустить выплату контрагенту вручную
 * Инициирует выплату контрагенту через T-Bank E2C API для указанного платежа. Поддерживаются ЮЛ (tbank_shop_code) и самозанятые/физлица (СБП: payment_recipient_phone + sbp_member_id). Платёж должен иметь статус SUCCESS и tbank_deal_id.
 * @param data The data for the request.
 * @param data.uuid UUID платежа
 * @returns unknown Выплата инициирована
 * @throws ApiError
 */
export const superadminTriggerPayout = (data: SuperadminTriggerPayoutData): CancelablePromise<SuperadminTriggerPayoutResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/payments/{uuid}/trigger-payout',
        path: {
            uuid: data.uuid
        },
        errors: {
            400: 'Некорректный статус платежа или отсутствует deal_id',
            401: 'Не авторизован',
            403: 'Нет прав доступа',
            404: 'Платёж не найден'
        }
    });
};

/**
 * Webhook от CloudPayments (Receipt)
 * @param data The data for the request.
 * @param data.xContentHmac
 * @param data.contentHmac
 * @returns unknown Webhook обработан
 * @throws ApiError
 */
export const receiptsControllerHandleWebhook = (data: ReceiptsControllerHandleWebhookData): CancelablePromise<ReceiptsControllerHandleWebhookResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/receipts/webhook',
        headers: {
            'X-Content-HMAC': data.xContentHmac,
            'Content-HMAC': data.contentHmac
        }
    });
};

/**
 * Чеки по платежу
 * @param data The data for the request.
 * @param data.paymentUuid
 * @throws ApiError
 */
export const receiptsControllerGetReceiptsByPayment = (data: ReceiptsControllerGetReceiptsByPaymentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/receipts/payment/{paymentUuid}',
        path: {
            paymentUuid: data.paymentUuid
        },
        errors: {
            403: 'Нет доступа к этому ресурсу'
        }
    });
};

/**
 * Чеки по бронированию
 * @param data The data for the request.
 * @param data.bookingUuid
 * @throws ApiError
 */
export const receiptsControllerGetReceiptsByBooking = (data: ReceiptsControllerGetReceiptsByBookingData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/receipts/booking/{bookingUuid}',
        path: {
            bookingUuid: data.bookingUuid
        },
        errors: {
            403: 'Нет доступа к этому ресурсу'
        }
    });
};

/**
 * Создать бронирование
 * Создает новое бронирование услуги в сервисном центре для указанного автомобиля клиента
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BookingResponseDto Бронирование успешно создано
 * @throws ApiError
 */
export const bookingCreate = (data: BookingCreateData): CancelablePromise<BookingCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/bookings',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные запроса',
            401: 'Не авторизован',
            404: 'Услуга, сервисный центр или автомобиль не найдены',
            409: 'Конфликт времени бронирования'
        }
    });
};

/**
 * Получить список бронирований клиента
 * Возвращает список всех бронирований авторизованного клиента с поддержкой пагинации
 * @param data The data for the request.
 * @param data.limit Количество записей для возврата
 * @param data.offset Смещение для пагинации
 * @returns BookingResponseDto Список бронирований успешно получен
 * @throws ApiError
 */
export const bookingList = (data: BookingListData = {}): CancelablePromise<BookingListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/bookings',
        query: {
            limit: data.limit,
            offset: data.offset
        },
        errors: {
            400: 'Некорректные параметры пагинации',
            401: 'Не авторизован'
        }
    });
};

/**
 * Получить детальную информацию о бронировании
 * Возвращает подробную информацию о бронировании с данными о клиенте, автомобиле, сервисном центре и услуге
 * @param data The data for the request.
 * @param data.uuid Уникальный идентификатор бронирования
 * @returns DetailedBookingResponseDto Детальная информация о бронировании получена
 * @throws ApiError
 */
export const bookingGetOne = (data: BookingGetOneData): CancelablePromise<BookingGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/bookings/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Бронирование не принадлежит клиенту',
            404: 'Бронирование не найдено'
        }
    });
};

/**
 * Отменить бронирование
 * Отменяет подтвержденное бронирование. Отмена возможна только за 24 часа до начала услуги
 * @param data The data for the request.
 * @param data.uuid Уникальный идентификатор бронирования
 * @returns BookingResponseDto Бронирование успешно отменено
 * @throws ApiError
 */
export const bookingCancel = (data: BookingCancelData): CancelablePromise<BookingCancelResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/bookings/{uuid}/cancel',
        path: {
            uuid: data.uuid
        },
        errors: {
            400: 'Бронирование нельзя отменить (менее 24 часов до начала или неподходящий статус)',
            401: 'Не авторизован',
            403: 'Бронирование не принадлежит клиенту',
            404: 'Бронирование не найдено'
        }
    });
};

/**
 * Получить информацию о платеже для бронирования
 * Возвращает информацию о платеже, связанном с указанным бронированием
 * @param data The data for the request.
 * @param data.uuid Уникальный идентификатор бронирования
 * @returns BookingPaymentResponseDto Информация о платеже получена
 * @throws ApiError
 */
export const bookingGetPayment = (data: BookingGetPaymentData): CancelablePromise<BookingGetPaymentResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/bookings/{uuid}/payment',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Доступ к платежу запрещен',
            404: 'Платеж для бронирования не найден'
        }
    });
};

/**
 * Получить список бронирований для админ-панели
 * Возвращает список бронирований сервисного центра с фильтрацией по датам и статусам. Требуется аутентификация админа и доступ к указанному сервисному центру через projectUuid.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.dateFrom Начало диапазона дат (ISO 8601)
 * @param data.dateTo Конец диапазона дат (ISO 8601)
 * @param data.status Массив статусов для фильтрации: pending_confirmation, confirmed, completed, cancelled
 * @param data.limit Количество записей (default: 100)
 * @param data.offset Смещение для пагинации (default: 0)
 * @returns AdminBookingListResponseDto Список бронирований успешно получен
 * @throws ApiError
 */
export const adminBookingsGetList = (data: AdminBookingsGetListData): CancelablePromise<AdminBookingsGetListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/bookings',
        query: {
            service_center_uuid: data.serviceCenterUuid,
            date_from: data.dateFrom,
            date_to: data.dateTo,
            status: data.status,
            limit: data.limit,
            offset: data.offset
        },
        errors: {
            400: 'Некорректные параметры запроса',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Создание бронирования администратором
 * Создает новое бронирование от имени администратора. Для будущих дат: бронирование создается со статусом 'confirmed', требуется указать payment_method. Для прошедших дат: автоматически устанавливается статус 'completed', payment_status=null, пропускаются проверки занятости слотов и не отправляются уведомления клиенту. Администратор может создавать множество бронирований на одно и то же время. Требуется аутентификация админа и доступ к указанному сервисному центру.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AdminCreateBookingResponseDto Бронирование успешно создано
 * @throws ApiError
 */
export const adminCreateBooking = (data: AdminCreateBookingData): CancelablePromise<AdminCreateBookingResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/bookings',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные запроса',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Клиент, автомобиль, услуга или сервисный центр не найдены'
        }
    });
};

/**
 * Получить бронирования в статусе pending_confirmation
 * Возвращает все бронирования сервисного центра в статусе ожидания подтверждения (pending_confirmation). Требуется аутентификация админа и доступ к указанному сервисному центру через projectUuid.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @returns AdminBookingListResponseDto Список бронирований в статусе pending_confirmation успешно получен
 * @throws ApiError
 */
export const adminBookingsGetPending = (data: AdminBookingsGetPendingData): CancelablePromise<AdminBookingsGetPendingResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/bookings/pending',
        query: {
            service_center_uuid: data.serviceCenterUuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить детальную информацию о бронировании
 * Возвращает подробную информацию о конкретном бронировании. Требуется аутентификация админа и доступ к сервисному центру через projectUuid.
 * @param data The data for the request.
 * @param data.uuid UUID бронирования
 * @returns DetailedBookingResponseDto Детальная информация о бронировании получена
 * @throws ApiError
 */
export const adminBookingsGetOne = (data: AdminBookingsGetOneData): CancelablePromise<AdminBookingsGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/bookings/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа к этому бронированию',
            404: 'Бронирование не найдено'
        }
    });
};

/**
 * Редактировать бронирование
 * Позволяет админу изменять параметры бронирования: время начала и окончания, пост, услугу, дополнительные услуги и комментарий. При только start_time запись сдвигается с сохранением текущей длительности. При start_time + end_time задаётся явная длительность (минимум 15 минут, кратно 15 минутам). При смене услуги без end_time длительность пересчитывается из услуг. Явный end_time имеет приоритет над пересчётом из услуг. Проверяется доступность слота на [start_time, end_time]. После успешного обновления клиенту отправляется push-уведомление.
 * @param data The data for the request.
 * @param data.uuid UUID бронирования
 * @param data.requestBody
 * @returns DetailedBookingResponseDto Бронирование успешно обновлено
 * @throws ApiError
 */
export const adminBookingsUpdate = (data: AdminBookingsUpdateData): CancelablePromise<AdminBookingsUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/bookings/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Невалидные данные, слот занят или нельзя редактировать в текущем статусе',
            401: 'Не авторизован',
            403: 'Нет доступа к этому бронированию',
            404: 'Бронирование не найдено',
            409: 'Временной слот занят'
        }
    });
};

/**
 * Изменить статус бронирования
 * Позволяет изменить статус бронирования с соблюдением правил переходов:
 * - pending_confirmation → confirmed, cancelled
 * - confirmed → completed, cancelled
 * - completed и cancelled — финальные статусы (нельзя изменить)
 *
 * При переходе в статус 'cancelled' для оплаченных бронирований автоматически устанавливается payment_status='refund_pending'.
 * @param data The data for the request.
 * @param data.uuid UUID бронирования
 * @param data.requestBody
 * @returns UpdateBookingStatusResponseDto Статус успешно изменен
 * @throws ApiError
 */
export const adminBookingsUpdateStatus = (data: AdminBookingsUpdateStatusData): CancelablePromise<AdminBookingsUpdateStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/bookings/{uuid}/status',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Невалидный переход статуса (например, попытка изменить финальный статус или недопустимый переход)',
            401: 'Не авторизован',
            403: 'Нет доступа к этому бронированию',
            404: 'Бронирование не найдено'
        }
    });
};

/**
 * Получить список бронирований контрагента
 * Возвращает бронирования всех сервисных центров, принадлежащих контрагенту текущего пользователя. Поддерживает фильтрацию по сервисному центру, диапазону дат и статусам, а также сортировку по ключевым полям. Требует пермишен master-service-bookings.view.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра для фильтрации (опционально — если не указан, возвращаются бронирования всех СЦ контрагента)
 * @param data.dateFrom Начало диапазона дат (ISO 8601). Опционально, если не указано — ограничений по начальной дате нет
 * @param data.dateTo Конец диапазона дат (ISO 8601). Опционально, если не указано — ограничений по конечной дате нет
 * @param data.status Массив статусов для фильтрации: pending_confirmation, confirmed, completed, cancelled
 * @param data.sortBy Поле сортировки
 * @param data.sortOrder Направление сортировки
 * @param data.limit Количество записей (default: 100, max: 200)
 * @param data.offset Смещение для пагинации (default: 0)
 * @returns AdminBookingListResponseDto Список бронирований успешно получен
 * @throws ApiError
 */
export const masterBookingsGetList = (data: MasterBookingsGetListData = {}): CancelablePromise<MasterBookingsGetListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/master/bookings',
        query: {
            service_center_uuid: data.serviceCenterUuid,
            date_from: data.dateFrom,
            date_to: data.dateTo,
            status: data.status,
            sort_by: data.sortBy,
            sort_order: data.sortOrder,
            limit: data.limit,
            offset: data.offset
        },
        errors: {
            400: 'Некорректные параметры запроса',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру'
        }
    });
};

/**
 * Агрегированные метрики по бронированиям
 * Возвращает метрики по сгруппированным бронированиям платформы. group_by: status, payment_status, service_center_uuid, service_uuid, created_by_source, start_time_day|week|month. metrics: count, sum_total_cost, avg_total_cost.
 * @param data The data for the request.
 * @param data.groupBy
 * @param data.metrics
 * @param data.limit
 * @returns GroupedResponseDto Сгруппированные метрики
 * @throws ApiError
 */
export const superadminGroupBookings = (data: SuperadminGroupBookingsData): CancelablePromise<SuperadminGroupBookingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/bookings/grouped',
        query: {
            group_by: data.groupBy,
            metrics: data.metrics,
            limit: data.limit
        }
    });
};

/**
 * Список всех бронирований платформы
 * Возвращает постраничный список бронирований по всем сервисным центрам с фильтрацией, сортировкой и поиском.
 * @returns unknown Список бронирований
 * @throws ApiError
 */
export const superadminListBookings = (): CancelablePromise<SuperadminListBookingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/bookings'
    });
};

/**
 * Регистрация Expo push токена
 * Регистрирует Expo push token устройства для получения push-уведомлений
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Токен успешно зарегистрирован
 * @throws ApiError
 */
export const registerNotificationToken = (data: RegisterNotificationTokenData): CancelablePromise<RegisterNotificationTokenResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/notifications/token',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            404: 'Пользователь не найден'
        }
    });
};

/**
 * Удаление Expo push токена
 * Удаляет Expo push token устройства
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Токен успешно удален
 * @throws ApiError
 */
export const unregisterNotificationToken = (data: UnregisterNotificationTokenData): CancelablePromise<UnregisterNotificationTokenResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/notifications/token',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            401: 'Не авторизован',
            404: 'Токен не найден'
        }
    });
};

/**
 * Получить настройки уведомлений
 * Возвращает настройки push-уведомлений пользователя
 * @returns NotificationSettingsDto Настройки успешно получены
 * @throws ApiError
 */
export const getNotificationSettings = (): CancelablePromise<GetNotificationSettingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notifications/settings',
        errors: {
            401: 'Не авторизован',
            404: 'Пользователь не найден'
        }
    });
};

/**
 * Обновить настройки уведомлений
 * Обновляет настройки push-уведомлений пользователя
 * @param data The data for the request.
 * @param data.requestBody
 * @returns NotificationSettingsDto Настройки успешно обновлены
 * @throws ApiError
 */
export const updateNotificationSettings = (data: UpdateNotificationSettingsData): CancelablePromise<UpdateNotificationSettingsResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/notifications/settings',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            404: 'Пользователь не найден'
        }
    });
};

/**
 * Получить список уведомлений
 * Возвращает список уведомлений текущего пользователя с пагинацией и фильтрами
 * @param data The data for the request.
 * @param data.page Номер страницы (начиная с 1)
 * @param data.limit Количество элементов на странице
 * @param data.isRead Фильтр по прочитанным уведомлениям (true/false)
 * @param data.type Фильтр по типу уведомления
 * @returns NotificationsListResponseDto Список уведомлений успешно получен
 * @throws ApiError
 */
export const getNotifications = (data: GetNotificationsData = {}): CancelablePromise<GetNotificationsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notifications',
        query: {
            page: data.page,
            limit: data.limit,
            isRead: data.isRead,
            type: data.type
        },
        errors: {
            401: 'Не авторизован'
        }
    });
};

/**
 * Пометить уведомление как прочитанное
 * Помечает конкретное уведомление как прочитанное
 * @param data The data for the request.
 * @param data.uuid
 * @returns NotificationResponseDto Уведомление успешно помечено как прочитанное
 * @throws ApiError
 */
export const markNotificationAsRead = (data: MarkNotificationAsReadData): CancelablePromise<MarkNotificationAsReadResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/notifications/{uuid}/read',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            404: 'Уведомление не найдено'
        }
    });
};

/**
 * Пометить все уведомления как прочитанные
 * Помечает все уведомления пользователя как прочитанные
 * @returns unknown Все уведомления успешно помечены как прочитанные
 * @throws ApiError
 */
export const markAllNotificationsAsRead = (): CancelablePromise<MarkAllNotificationsAsReadResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/notifications/read-all',
        errors: {
            401: 'Не авторизован'
        }
    });
};

/**
 * Получить количество непрочитанных уведомлений
 * Возвращает количество непрочитанных уведомлений пользователя
 * @returns unknown Количество непрочитанных уведомлений успешно получено
 * @throws ApiError
 */
export const getUnreadNotificationsCount = (): CancelablePromise<GetUnreadNotificationsCountResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notifications/unread-count',
        errors: {
            401: 'Не авторизован'
        }
    });
};

/**
 * Список клиентов, которым можно отправить push
 * Возвращает клиентов с активным Expo-токеном (разрешили push и зарегистрировали устройство).
 * @param data The data for the request.
 * @param data.page
 * @param data.limit
 * @param data.q Поиск по имени, телефону или email
 * @param data.sort Сортировка: created_at, name, -created_at, -name
 * @returns SuperadminPushableClientsListResponseDto Список получателей push
 * @throws ApiError
 */
export const superadminListPushableClients = (data: SuperadminListPushableClientsData = {}): CancelablePromise<SuperadminListPushableClientsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/notifications/pushable-clients',
        query: {
            page: data.page,
            limit: data.limit,
            q: data.q,
            sort: data.sort
        }
    });
};

/**
 * Отправить push-уведомления клиентам
 * Отправляет маркетинговый push выбранным клиентам или всем, подходящим под фильтр.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SuperadminSendPushNotificationsResponseDto Результат отправки push
 * @throws ApiError
 */
export const superadminSendPushNotifications = (data: SuperadminSendPushNotificationsData): CancelablePromise<SuperadminSendPushNotificationsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/notifications/send',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные'
        }
    });
};

/**
 * Получить список марок автомобилей
 * Возвращает пагинированный список всех марок автомобилей
 * @param data The data for the request.
 * @param data.page Номер страницы (начинается с 1)
 * @param data.limit Количество элементов на странице
 * @returns unknown Список марок успешно получен
 * @throws ApiError
 */
export const carsControllerGetMakes = (data: CarsControllerGetMakesData = {}): CancelablePromise<CarsControllerGetMakesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cars/makes',
        query: {
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Получить модели автомобиля по марке
 * Возвращает пагинированный список моделей для указанной марки автомобиля
 * @param data The data for the request.
 * @param data.id Идентификатор марки автомобиля
 * @param data.page Номер страницы (начинается с 1)
 * @param data.limit Количество элементов на странице
 * @returns unknown Список моделей успешно получен
 * @throws ApiError
 */
export const carsControllerGetModelsByMakeId = (data: CarsControllerGetModelsByMakeIdData): CancelablePromise<CarsControllerGetModelsByMakeIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cars/makes/{id}/models',
        path: {
            id: data.id
        },
        query: {
            page: data.page,
            limit: data.limit
        },
        errors: {
            404: 'Марка автомобиля не найдена'
        }
    });
};

/**
 * Поиск автомобилей по номеру
 * Ищет автомобили по частичному или полному номеру. Поиск регистронезависимый, без учета пробелов. Опционально можно фильтровать по клиенту. Требуется аутентификация админа.
 * @param data The data for the request.
 * @param data.licensePlate Частичный или полный номер автомобиля (минимум 2 символа). Опционально, если передан client_uuid
 * @param data.clientUuid UUID клиента для фильтрации по конкретному клиенту
 * @param data.limit Количество результатов
 * @returns CarSearchResultDto Список найденных автомобилей
 * @throws ApiError
 */
export const adminSearchCars = (data: AdminSearchCarsData = {}): CancelablePromise<AdminSearchCarsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/cars/search',
        query: {
            license_plate: data.licensePlate,
            client_uuid: data.clientUuid,
            limit: data.limit
        },
        errors: {
            400: 'Неверные параметры запроса',
            401: 'Не авторизован',
            403: 'Недостаточно прав (не админ)'
        }
    });
};

/**
 * Получить список всех услуг
 * Возвращает список услуг с возможностью фильтрации по различным параметрам. Услуги фильтруются по проекту текущего пользователя.
 * @param data The data for the request.
 * @param data.businessType Тип бизнеса (мойка или шиномонтаж)
 * @param data.serviceType Тип услуги (основная или дополнительная)
 * @param data.category Категория услуги
 * @param data.isActive Фильтр по активности
 * @returns Service Список услуг успешно получен
 * @throws ApiError
 */
export const adminServicesGetAll = (data: AdminServicesGetAllData = {}): CancelablePromise<AdminServicesGetAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/services',
        query: {
            business_type: data.businessType,
            service_type: data.serviceType,
            category: data.category,
            is_active: data.isActive
        },
        errors: {
            401: 'Не авторизован',
            403: 'Нет доступа'
        }
    });
};

/**
 * Создать новую услугу
 * Создает новую услугу с ценами в системе
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Service Услуга успешно создана
 * @throws ApiError
 */
export const adminServicesCreate = (data: AdminServicesCreateData): CancelablePromise<AdminServicesCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/services',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Нет доступа (только ADMIN)'
        }
    });
};

/**
 * Получить детальную информацию об услуге
 * Возвращает полную информацию об услуге включая все цены
 * @param data The data for the request.
 * @param data.uuid UUID услуги
 * @returns Service Услуга успешно получена
 * @throws ApiError
 */
export const adminServicesGetOne = (data: AdminServicesGetOneData): CancelablePromise<AdminServicesGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/services/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            404: 'Услуга не найдена'
        }
    });
};

/**
 * Обновить существующую услугу
 * Обновляет данные услуги и её цены
 * @param data The data for the request.
 * @param data.uuid UUID услуги
 * @param data.requestBody
 * @returns Service Услуга успешно обновлена
 * @throws ApiError
 */
export const adminServicesUpdate = (data: AdminServicesUpdateData): CancelablePromise<AdminServicesUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/admin/services/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Некорректные данные',
            401: 'Не авторизован',
            403: 'Нет доступа (только ADMIN)',
            404: 'Услуга не найдена'
        }
    });
};

/**
 * Удалить услугу (soft delete)
 * Выполняет мягкое удаление услуги. Проверяет наличие активных бронирований
 * @param data The data for the request.
 * @param data.uuid UUID услуги
 * @returns unknown Услуга успешно удалена
 * @throws ApiError
 */
export const adminServicesDelete = (data: AdminServicesDeleteData): CancelablePromise<AdminServicesDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/services/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            400: 'Невозможно удалить услугу (есть активные бронирования)',
            401: 'Не авторизован',
            403: 'Нет доступа (только ADMIN)',
            404: 'Услуга не найдена'
        }
    });
};

/**
 * Получить общую статистику за период
 * Возвращает общую статистику сервисного центра за указанный период:
 * - Общее количество записей
 * - Количество подтверждённых записей
 * - Количество не состоявшихся записей
 * - Общая выручка
 *
 * Для каждой метрики предоставляется текущее значение и процент изменения по сравнению с предыдущим периодом той же длительности.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.dateFrom Дата начала периода в формате ISO 8601
 * @param data.dateTo Дата окончания периода в формате ISO 8601
 * @param data.period Период для сравнения статистики
 * @returns AnalyticsStatsResponseDto Статистика успешно получена
 * @throws ApiError
 */
export const adminAnalyticsGetStats = (data: AdminAnalyticsGetStatsData): CancelablePromise<AdminAnalyticsGetStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/analytics/stats',
        query: {
            service_center_uuid: data.serviceCenterUuid,
            date_from: data.dateFrom,
            date_to: data.dateTo,
            period: data.period
        },
        errors: {
            400: 'Некорректные параметры запроса',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить топ популярных услуг
 * Возвращает список наиболее популярных услуг за указанный период, отсортированных по количеству записей.
 * Для каждой услуги предоставляется:
 * - Название услуги
 * - Количество записей
 * - Общая выручка
 *
 * По умолчанию возвращается топ 10 услуг, но можно настроить через параметр limit (максимум 50).
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.dateFrom Дата начала периода в формате ISO 8601
 * @param data.dateTo Дата окончания периода в формате ISO 8601
 * @param data.limit Максимальное количество услуг в топе
 * @returns AnalyticsTopServicesResponseDto Топ услуг успешно получен
 * @throws ApiError
 */
export const adminAnalyticsGetTopServices = (data: AdminAnalyticsGetTopServicesData): CancelablePromise<AdminAnalyticsGetTopServicesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/analytics/top-services',
        query: {
            service_center_uuid: data.serviceCenterUuid,
            date_from: data.dateFrom,
            date_to: data.dateTo,
            limit: data.limit
        },
        errors: {
            400: 'Некорректные параметры запроса',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить данные графика загрузки
 * Возвращает данные для построения графика загрузки сервисного центра.
 *
 * Поддерживает два режима в зависимости от параметра period:
 * - **week**: Группировка по дням недели (Понедельник-Воскресенье), возвращает 7 точек данных
 * - **day**: Группировка по часам (0-23), возвращает 24 точки данных
 *
 * Каждая точка данных содержит метку (день недели или час) и количество записей.
 * @param data The data for the request.
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.dateFrom Дата начала периода в формате ISO 8601
 * @param data.dateTo Дата окончания периода в формате ISO 8601
 * @param data.period Период группировки данных графика (по дням недели или по часам)
 * @returns AnalyticsLoadChartResponseDto Данные графика загрузки успешно получены
 * @throws ApiError
 */
export const adminAnalyticsGetLoadChart = (data: AdminAnalyticsGetLoadChartData): CancelablePromise<AdminAnalyticsGetLoadChartResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/analytics/load-chart',
        query: {
            service_center_uuid: data.serviceCenterUuid,
            date_from: data.dateFrom,
            date_to: data.dateTo,
            period: data.period
        },
        errors: {
            400: 'Некорректные параметры запроса',
            401: 'Не авторизован',
            403: 'Нет доступа к указанному сервисному центру',
            404: 'Сервисный центр не найден'
        }
    });
};

/**
 * Получить аудит-логи с фильтрацией и пагинацией
 * Возвращает список аудит-логов. Доступно фильтрование по клиенту, бронированию, сервисному центру, типу действия и периоду.
 * @param data The data for the request.
 * @param data.clientUuid UUID клиента
 * @param data.adminUuid UUID администратора
 * @param data.action Тип действия
 * @param data.paymentUuid UUID платежа
 * @param data.bookingUuid UUID бронирования
 * @param data.serviceCenterUuid UUID сервисного центра
 * @param data.serviceUuid UUID услуги
 * @param data.dateFrom Начало периода (ISO 8601)
 * @param data.dateTo Конец периода (ISO 8601)
 * @param data.limit Количество записей (макс. 200)
 * @param data.offset Смещение
 * @returns unknown Список аудит-логов
 * @throws ApiError
 */
export const auditLogsList = (data: AuditLogsListData = {}): CancelablePromise<AuditLogsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/audit-logs',
        query: {
            client_uuid: data.clientUuid,
            admin_uuid: data.adminUuid,
            action: data.action,
            payment_uuid: data.paymentUuid,
            booking_uuid: data.bookingUuid,
            service_center_uuid: data.serviceCenterUuid,
            service_uuid: data.serviceUuid,
            date_from: data.dateFrom,
            date_to: data.dateTo,
            limit: data.limit,
            offset: data.offset
        },
        errors: {
            401: 'Не авторизован',
            403: 'Доступ запрещён'
        }
    });
};

/**
 * Получить аудит-лог по UUID
 * @param data The data for the request.
 * @param data.uuid
 * @returns unknown Аудит-лог
 * @throws ApiError
 */
export const auditLogGet = (data: AuditLogGetData): CancelablePromise<AuditLogGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/audit-logs/{uuid}',
        path: {
            uuid: data.uuid
        },
        errors: {
            401: 'Не авторизован',
            403: 'Доступ запрещён',
            404: 'Запись не найдена'
        }
    });
};

/**
 * Поиск организации по названию/ИНН
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dadataControllerSuggestParty = (data: DadataControllerSuggestPartyData): CancelablePromise<DadataControllerSuggestPartyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dadata/suggest/party',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить организацию по ИНН/ОГРН
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dadataControllerFindParty = (data: DadataControllerFindPartyData): CancelablePromise<DadataControllerFindPartyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dadata/find-by-id/party',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Поиск банка по названию/БИК
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dadataControllerSuggestBank = (data: DadataControllerSuggestBankData): CancelablePromise<DadataControllerSuggestBankResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dadata/suggest/bank',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить банк по БИК
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dadataControllerFindBank = (data: DadataControllerFindBankData): CancelablePromise<DadataControllerFindBankResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dadata/find-by-id/bank',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Подсказки адресов по введённой строке
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dadataControllerSuggestAddress = (data: DadataControllerSuggestAddressData): CancelablePromise<DadataControllerSuggestAddressResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dadata/suggest/address',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Стандартизация адресов (cleaner API)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const dadataControllerCleanAddress = (data: DadataControllerCleanAddressData): CancelablePromise<DadataControllerCleanAddressResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dadata/clean/address',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить настройки уведомлений обратной связи
 * @returns FeedbackSettingsResponseDto Настройки уведомлений
 * @throws ApiError
 */
export const adminFeedbackSettingsGet = (): CancelablePromise<AdminFeedbackSettingsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/feedback/settings'
    });
};

/**
 * Обновить настройки уведомлений обратной связи
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FeedbackSettingsResponseDto Обновлённые настройки
 * @throws ApiError
 */
export const adminFeedbackSettingsUpdate = (data: AdminFeedbackSettingsUpdateData): CancelablePromise<AdminFeedbackSettingsUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/admin/feedback/settings',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить активные темы обращений
 * Публичный список тем для формы обратной связи
 * @returns TopicResponseDto Список активных тем
 * @throws ApiError
 */
export const feedbackTopicsList = (): CancelablePromise<FeedbackTopicsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/feedback/topics'
    });
};

/**
 * Создать тему обращения
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TopicResponseDto Тема создана
 * @throws ApiError
 */
export const adminFeedbackTopicCreate = (data: AdminFeedbackTopicCreateData): CancelablePromise<AdminFeedbackTopicCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/feedback/topics',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить все темы обращений
 * @returns TopicResponseDto Список тем
 * @throws ApiError
 */
export const adminFeedbackTopicList = (): CancelablePromise<AdminFeedbackTopicListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/feedback/topics'
    });
};

/**
 * Обновить тему обращения
 * @param data The data for the request.
 * @param data.uuid UUID темы
 * @param data.requestBody
 * @returns TopicResponseDto Тема обновлена
 * @throws ApiError
 */
export const adminFeedbackTopicUpdate = (data: AdminFeedbackTopicUpdateData): CancelablePromise<AdminFeedbackTopicUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/feedback/topics/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Удалить тему обращения
 * @param data The data for the request.
 * @param data.uuid UUID темы
 * @returns void Тема удалена
 * @throws ApiError
 */
export const adminFeedbackTopicDelete = (data: AdminFeedbackTopicDeleteData): CancelablePromise<AdminFeedbackTopicDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/feedback/topics/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Отправить обращение
 * Создает обращение в службу поддержки. Доступно авторизованным и неавторизованным пользователям.
 * @param data The data for the request.
 * @param data.formData
 * @returns FeedbackResponseDto Обращение успешно создано
 * @throws ApiError
 */
export const feedbackCreate = (data: FeedbackCreateData): CancelablePromise<FeedbackCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/feedback',
        formData: data.formData,
        mediaType: 'multipart/form-data'
    });
};

/**
 * Получить список обращений
 * Поддерживает пагинацию, фильтры по статусу и теме, поиск по теме, имени, email, телефону отправителя и тексту обращения (параметр search).
 * @param data The data for the request.
 * @param data.page Номер страницы
 * @param data.limit Размер страницы
 * @param data.status Фильтр по статусу
 * @param data.topicUuid Фильтр по теме обращения
 * @param data.search Поиск по теме, имени, email, телефону отправителя и тексту обращения
 * @returns unknown Список обращений
 * @throws ApiError
 */
export const adminFeedbackList = (data: AdminFeedbackListData = {}): CancelablePromise<AdminFeedbackListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/feedback',
        query: {
            page: data.page,
            limit: data.limit,
            status: data.status,
            topic_uuid: data.topicUuid,
            search: data.search
        }
    });
};

/**
 * Получить обращение по UUID
 * @param data The data for the request.
 * @param data.uuid UUID обращения
 * @returns FeedbackDetailResponseDto Детали обращения с хронологией событий
 * @throws ApiError
 */
export const adminFeedbackGetOne = (data: AdminFeedbackGetOneData): CancelablePromise<AdminFeedbackGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/feedback/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Удалить обращение
 * @param data The data for the request.
 * @param data.uuid UUID обращения
 * @returns void Обращение удалено
 * @throws ApiError
 */
export const adminFeedbackDelete = (data: AdminFeedbackDeleteData): CancelablePromise<AdminFeedbackDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/feedback/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Добавить комментарий к обращению
 * @param data The data for the request.
 * @param data.uuid UUID обращения
 * @param data.requestBody
 * @returns FeedbackTimelineEventDto Комментарий добавлен
 * @throws ApiError
 */
export const adminFeedbackAddComment = (data: AdminFeedbackAddCommentData): CancelablePromise<AdminFeedbackAddCommentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/feedback/{uuid}/comments',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Изменить статус обращения
 * @param data The data for the request.
 * @param data.uuid UUID обращения
 * @param data.requestBody
 * @returns FeedbackDetailResponseDto Статус обновлен
 * @throws ApiError
 */
export const adminFeedbackUpdateStatus = (data: AdminFeedbackUpdateStatusData): CancelablePromise<AdminFeedbackUpdateStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/feedback/{uuid}/status',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить список частых вопросов
 * Публичный список активных FAQ
 * @returns FaqResponseDto Список активных FAQ
 * @throws ApiError
 */
export const faqList = (): CancelablePromise<FaqListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/faq'
    });
};

/**
 * Создать частый вопрос
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FaqResponseDto Вопрос создан
 * @throws ApiError
 */
export const adminFaqCreate = (data: AdminFaqCreateData): CancelablePromise<AdminFaqCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/faq',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить все частые вопросы
 * @returns FaqResponseDto Список FAQ
 * @throws ApiError
 */
export const adminFaqList = (): CancelablePromise<AdminFaqListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/faq'
    });
};

/**
 * Получить частый вопрос по UUID
 * @param data The data for the request.
 * @param data.uuid UUID вопроса
 * @returns FaqResponseDto Детали вопроса
 * @throws ApiError
 */
export const adminFaqGetOne = (data: AdminFaqGetOneData): CancelablePromise<AdminFaqGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/faq/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Обновить частый вопрос
 * @param data The data for the request.
 * @param data.uuid UUID вопроса
 * @param data.requestBody
 * @returns FaqResponseDto Вопрос обновлен
 * @throws ApiError
 */
export const adminFaqUpdate = (data: AdminFaqUpdateData): CancelablePromise<AdminFaqUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/faq/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Удалить частый вопрос
 * @param data The data for the request.
 * @param data.uuid UUID вопроса
 * @returns void Вопрос удален
 * @throws ApiError
 */
export const adminFaqDelete = (data: AdminFaqDeleteData): CancelablePromise<AdminFaqDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/faq/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Получить список заправок
 * Возвращает список заправок (uuid, координаты, название, статус, цены). Фильтрация по bbox или lat/lon/radius_km — только если переданы координаты. Пагинация включается при передаче limit.
 * @param data The data for the request.
 * @param data.queue Фильтр по статусу очереди: yes — только status yes и queue, no — только status yes. Если не передан — фильтр не применяется
 * @param data.lat Широта пользователя
 * @param data.lon Долгота пользователя
 * @param data.radiusKm Радиус поиска в км
 * @param data.bboxLat1 Широта первой угловой точки видимой области карты (например, левый нижний угол)
 * @param data.bboxLon1 Долгота первой угловой точки видимой области карты (например, левый нижний угол)
 * @param data.bboxLat2 Широта второй угловой точки видимой области карты (например, правый верхний угол)
 * @param data.bboxLon2 Долгота второй угловой точки видимой области карты (например, правый верхний угол)
 * @param data.page Номер страницы (начиная с 1). Учитывается только при переданном limit
 * @param data.limit Количество элементов на странице. Если не передан — возвращаются все записи без пагинации
 * @returns GasStationsListResponseDto Список заправок
 * @throws ApiError
 */
export const gasStationsList = (data: GasStationsListData = {}): CancelablePromise<GasStationsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/gas-stations',
        query: {
            queue: data.queue,
            lat: data.lat,
            lon: data.lon,
            radius_km: data.radiusKm,
            bbox_lat1: data.bboxLat1,
            bbox_lon1: data.bboxLon1,
            bbox_lat2: data.bboxLat2,
            bbox_lon2: data.bboxLon2,
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Добавить заправку пользователем
 * Создаёт новую заправку на основе данных пользователя и сохраняет первый отчёт в историю.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GasStationResponseDto Заправка создана
 * @throws ApiError
 */
export const gasStationsCreateUser = (data: GasStationsCreateUserData): CancelablePromise<GasStationsCreateUserResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/gas-stations',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить кластеризованные данные карты заправок
 * Возвращает смесь серверных кластеров и отдельных точек для viewport карты. На дальнем зуме или при большом числе точек — mode=clustered, иначе mode=points.
 * @param data The data for the request.
 * @param data.bboxLat1 Широта первой угловой точки видимой области карты (например, левый нижний угол)
 * @param data.bboxLon1 Долгота первой угловой точки видимой области карты (например, левый нижний угол)
 * @param data.bboxLat2 Широта второй угловой точки видимой области карты (например, правый верхний угол)
 * @param data.bboxLon2 Долгота второй угловой точки видимой области карты (например, правый верхний угол)
 * @param data.zoom Текущий уровень зума карты
 * @param data.queue Фильтр по статусу очереди: yes — только status yes и queue, no — только status yes
 * @param data.fuels Фильтр по типам топлива: список полей price_* через запятую (например price_ai_92,price_dt). Заправка попадает в выборку, если доступно хотя бы одно из указанных топлив.
 * @param data.canisterOnly Показывать только АЗС с заправкой в канистру
 * @returns GasStationsMapResponseDto Кластеры и/или точки для карты
 * @throws ApiError
 */
export const gasStationsMap = (data: GasStationsMapData): CancelablePromise<GasStationsMapResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/gas-stations/map',
        query: {
            bbox_lat1: data.bboxLat1,
            bbox_lon1: data.bboxLon1,
            bbox_lat2: data.bboxLat2,
            bbox_lon2: data.bboxLon2,
            zoom: data.zoom,
            queue: data.queue,
            fuels: data.fuels,
            canister_only: data.canisterOnly
        }
    });
};

/**
 * Подписки пользователя на изменения АЗС
 * @returns GasStationSubscriptionResponseDto Список подписок
 * @throws ApiError
 */
export const gasStationsListSubscriptions = (): CancelablePromise<GasStationsListSubscriptionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/gas-stations/subscriptions'
    });
};

/**
 * Избранные заправки пользователя
 * Возвращает список избранных активных заправок в том же формате, что и GET /gas-stations.
 * @returns GasStationsListResponseDto Список избранных заправок
 * @throws ApiError
 */
export const gasStationsListFavorites = (): CancelablePromise<GasStationsListFavoritesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/gas-stations/favorites'
    });
};

/**
 * Получить заправку по UUID
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @returns GasStationResponseDto Детали заправки
 * @throws ApiError
 */
export const gasStationsGetOne = (data: GasStationsGetOneData): CancelablePromise<GasStationsGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/gas-stations/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Добавить/удалить АЗС из избранного
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @returns ToggleGasStationFavoriteResponseDto Статус избранного изменён
 * @throws ApiError
 */
export const gasStationToggleFavorite = (data: GasStationToggleFavoriteData): CancelablePromise<GasStationToggleFavoriteResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/gas-stations/{uuid}/favorite',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Подписаться на появление топлива на АЗС
 * Создаёт или обновляет подписку на уведомления о появлении выбранных видов топлива.
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @param data.requestBody
 * @returns GasStationSubscriptionResponseDto Подписка сохранена
 * @throws ApiError
 */
export const gasStationUpsertSubscription = (data: GasStationUpsertSubscriptionData): CancelablePromise<GasStationUpsertSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/gas-stations/{uuid}/subscription',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Отписаться от уведомлений по АЗС
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @returns void Подписка удалена
 * @throws ApiError
 */
export const gasStationRemoveSubscription = (data: GasStationRemoveSubscriptionData): CancelablePromise<GasStationRemoveSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/gas-stations/{uuid}/subscription',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Подтвердить информацию о заправке
 * Сохраняет отчёт пользователя в историю и пересчитывает средневзвешенные значения, если нет админ-оверрайда.
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @param data.requestBody
 * @returns GasStationResponseDto Отчёт сохранён
 * @throws ApiError
 */
export const gasStationsSubmitReport = (data: GasStationsSubmitReportData): CancelablePromise<GasStationsSubmitReportResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/gas-stations/{uuid}/report',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Bulk-обновление доступности АЗС из автоимпорта
 * Принимает batch наблюдений от сканера (source_code), пишет историю и пересчитывает status/fuel/queue по окну 24ч. Auth: admin JWT или X-Gas-Station-Scan-Token.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BulkGasStationScanResponseDto Скан обработан
 * @throws ApiError
 */
export const adminGasStationsBulkScan = (data: AdminGasStationsBulkScanData): CancelablePromise<AdminGasStationsBulkScanResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/gas-stations/scans/bulk',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Создать заправку (админ)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GasStationResponseDto Заправка создана
 * @throws ApiError
 */
export const adminGasStationsCreate = (data: AdminGasStationsCreateData): CancelablePromise<AdminGasStationsCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/admin/gas-stations',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить все заправки (админ)
 * @returns GasStationResponseDto Список заправок
 * @throws ApiError
 */
export const adminGasStationsList = (): CancelablePromise<AdminGasStationsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/gas-stations'
    });
};

/**
 * Получить заправку по UUID (админ)
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @returns GasStationResponseDto Детали заправки
 * @throws ApiError
 */
export const adminGasStationsGetOne = (data: AdminGasStationsGetOneData): CancelablePromise<AdminGasStationsGetOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/gas-stations/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Обновить заправку (админ)
 * Админские изменения статуса и цен считаются точными и блокируют пересчёт из пользовательских отчётов.
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @param data.requestBody
 * @returns GasStationResponseDto Заправка обновлена
 * @throws ApiError
 */
export const adminGasStationsUpdate = (data: AdminGasStationsUpdateData): CancelablePromise<AdminGasStationsUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/admin/gas-stations/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Удалить заправку
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @returns void Заправка удалена
 * @throws ApiError
 */
export const adminGasStationsDelete = (data: AdminGasStationsDeleteData): CancelablePromise<AdminGasStationsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/admin/gas-stations/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * История отчётов по заправке
 * @param data The data for the request.
 * @param data.uuid UUID заправки
 * @returns GasStationReportResponseDto История отчётов
 * @throws ApiError
 */
export const adminGasStationsReports = (data: AdminGasStationsReportsData): CancelablePromise<AdminGasStationsReportsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/gas-stations/{uuid}/reports',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Получить публичные настройки приложения
 * Возвращает публичные настройки мобильного приложения: табы, URL API и админ-панели
 * @returns PublicSystemSettingsResponseDto Публичные настройки
 * @throws ApiError
 */
export const systemSettingsGetPublic = (): CancelablePromise<SystemSettingsGetPublicResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/system-settings'
    });
};

/**
 * Получить все глобальные настройки системы
 * @returns SystemSettingsResponseDto Глобальные настройки (key-value)
 * @throws ApiError
 */
export const adminSystemSettingsGet = (): CancelablePromise<AdminSystemSettingsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/system-settings'
    });
};

/**
 * Обновить одну или несколько глобальных настроек
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SystemSettingsResponseDto Обновлённые настройки
 * @throws ApiError
 */
export const adminSystemSettingsUpdate = (data: AdminSystemSettingsUpdateData): CancelablePromise<AdminSystemSettingsUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/admin/system-settings',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Получить настройку по ключу
 * @param data The data for the request.
 * @param data.key Ключ настройки
 * @returns SystemSettingEntryDto Настройка
 * @throws ApiError
 */
export const adminSystemSettingsGetByKey = (data: AdminSystemSettingsGetByKeyData): CancelablePromise<AdminSystemSettingsGetByKeyResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/admin/system-settings/{key}',
        path: {
            key: data.key
        }
    });
};

/**
 * Каталог услуг помощи на дороге
 * Карточки для клиентского шита: эвакуация, топливо, прикурить. Допуслуги не отдаются.
 * @returns HelpClientServiceDto
 * @throws ApiError
 */
export const helpListServices = (): CancelablePromise<HelpListServicesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/help/services'
    });
};

/**
 * Предпросмотр стоимости заявки помощи
 * @param data The data for the request.
 * @param data.requestBody
 * @returns HelpQuoteResponseDto
 * @throws ApiError
 */
export const helpQuote = (data: HelpQuoteData): CancelablePromise<HelpQuoteResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/help/quote',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Активная заявка помощи текущего клиента
 * @returns HelpActiveOrderResponseDto
 * @throws ApiError
 */
export const helpGetActiveOrder = (): CancelablePromise<HelpGetActiveOrderResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/help/orders/active'
    });
};

/**
 * Создать заявку помощи
 * Создаёт заявку сразу в статусе awaiting_confirmation с успешной предоплатой (v1 без эквайринга).
 * @param data The data for the request.
 * @param data.formData
 * @returns HelpOrderDto
 * @throws ApiError
 */
export const helpCreateOrder = (data: HelpCreateOrderData): CancelablePromise<HelpCreateOrderResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/help/orders',
        formData: data.formData,
        mediaType: 'multipart/form-data'
    });
};

/**
 * Получить заявку помощи клиента
 * @param data The data for the request.
 * @param data.uuid
 * @returns HelpOrderDto
 * @throws ApiError
 */
export const helpGetOrder = (data: HelpGetOrderData): CancelablePromise<HelpGetOrderResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/help/orders/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Отменить заявку помощи
 * @param data The data for the request.
 * @param data.uuid
 * @returns HelpOrderDto
 * @throws ApiError
 */
export const helpCancelOrder = (data: HelpCancelOrderData): CancelablePromise<HelpCancelOrderResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/help/orders/{uuid}/cancel',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Метрики заявок помощи
 * @returns HelpOrdersMetricsDto
 * @throws ApiError
 */
export const superadminHelpOrdersMetrics = (): CancelablePromise<SuperadminHelpOrdersMetricsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/help/orders/metrics'
    });
};

/**
 * Список заявок помощи
 * @returns SuperadminHelpOrdersListResponseDto
 * @throws ApiError
 */
export const superadminListHelpOrders = (): CancelablePromise<SuperadminListHelpOrdersResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/help/orders'
    });
};

/**
 * Карточка заявки помощи
 * @param data The data for the request.
 * @param data.uuid
 * @returns SuperadminHelpOrderDetailDto
 * @throws ApiError
 */
export const superadminGetHelpOrder = (data: SuperadminGetHelpOrderData): CancelablePromise<SuperadminGetHelpOrderResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/help/orders/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Обновить заявку помощи
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns SuperadminHelpOrderDetailDto
 * @throws ApiError
 */
export const superadminUpdateHelpOrder = (data: SuperadminUpdateHelpOrderData): CancelablePromise<SuperadminUpdateHelpOrderResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/superadmin/help/orders/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Сменить статус заявки помощи
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns SuperadminHelpOrderDetailDto
 * @throws ApiError
 */
export const superadminUpdateHelpOrderStatus = (data: SuperadminUpdateHelpOrderStatusData): CancelablePromise<SuperadminUpdateHelpOrderStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/superadmin/help/orders/{uuid}/status',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Добавить комментарий диспетчера
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns SuperadminHelpOrderDetailDto
 * @throws ApiError
 */
export const superadminCommentHelpOrder = (data: SuperadminCommentHelpOrderData): CancelablePromise<SuperadminCommentHelpOrderResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/help/orders/{uuid}/comments',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Зафиксировать уведомление клиенту
 * В v1 только событие в таймлайне, без push.
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns SuperadminHelpOrderDetailDto
 * @throws ApiError
 */
export const superadminNotifyHelpOrder = (data: SuperadminNotifyHelpOrderData): CancelablePromise<SuperadminNotifyHelpOrderResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/help/orders/{uuid}/notify',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Каталог услуг помощи
 * @returns HelpServiceAdminDto
 * @throws ApiError
 */
export const superadminListHelpServices = (): CancelablePromise<SuperadminListHelpServicesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/help/services'
    });
};

/**
 * Создать услугу помощи
 * @param data The data for the request.
 * @param data.requestBody
 * @returns HelpServiceAdminDto
 * @throws ApiError
 */
export const superadminCreateHelpService = (data: SuperadminCreateHelpServiceData): CancelablePromise<SuperadminCreateHelpServiceResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/help/services',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Обновить услугу помощи
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns HelpServiceAdminDto
 * @throws ApiError
 */
export const superadminUpdateHelpService = (data: SuperadminUpdateHelpServiceData): CancelablePromise<SuperadminUpdateHelpServiceResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/superadmin/help/services/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Удалить услугу помощи
 * @param data The data for the request.
 * @param data.uuid
 * @returns void
 * @throws ApiError
 */
export const superadminDeleteHelpService = (data: SuperadminDeleteHelpServiceData): CancelablePromise<SuperadminDeleteHelpServiceResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/superadmin/help/services/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};

/**
 * Справочник исполнителей помощи
 * @returns HelpExecutorAdminDto
 * @throws ApiError
 */
export const superadminListHelpExecutors = (): CancelablePromise<SuperadminListHelpExecutorsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/superadmin/help/executors'
    });
};

/**
 * Создать исполнителя
 * @param data The data for the request.
 * @param data.requestBody
 * @returns HelpExecutorAdminDto
 * @throws ApiError
 */
export const superadminCreateHelpExecutor = (data: SuperadminCreateHelpExecutorData): CancelablePromise<SuperadminCreateHelpExecutorResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/superadmin/help/executors',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Обновить исполнителя
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns HelpExecutorAdminDto
 * @throws ApiError
 */
export const superadminUpdateHelpExecutor = (data: SuperadminUpdateHelpExecutorData): CancelablePromise<SuperadminUpdateHelpExecutorResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/superadmin/help/executors/{uuid}',
        path: {
            uuid: data.uuid
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Удалить исполнителя
 * @param data The data for the request.
 * @param data.uuid
 * @returns void
 * @throws ApiError
 */
export const superadminDeleteHelpExecutor = (data: SuperadminDeleteHelpExecutorData): CancelablePromise<SuperadminDeleteHelpExecutorResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/superadmin/help/executors/{uuid}',
        path: {
            uuid: data.uuid
        }
    });
};